(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AppConfig;
/**
 * @ngdoc function
 * @name app-v-vplus: AppConfig
 * @description
 * This config is setting up:
 *
 * - The translate plugin
 * - The app config
 */
function AppConfig($translateProvider, $compileProvider, $logProvider, $windowProvider, $httpProvider, $locationProvider, vAppConfigVPlusProvider, localStorageServiceProvider) {
    var appConfig = vAppConfigVPlusProvider.$get();
    var doc = $windowProvider.$get().document;
    var lang = doc.documentElement.getAttribute('lang') || 'fr';
    var isDebug = !!appConfig.DEBUG;

    localStorageServiceProvider.setPrefix('videotron').setStorageType('sessionStorage');

    $translateProvider.useSanitizeValueStrategy('escapeParameters');
    $translateProvider.translations('en', appConfig.i18n.en);
    $translateProvider.translations('fr', appConfig.i18n.fr);
    $translateProvider.use(lang);

    $logProvider.debugEnabled(isDebug);
    $compileProvider.debugInfoEnabled(isDebug);

    $httpProvider.defaults.withCredentials = true;
}

AppConfig.$inject = ['$translateProvider', '$compileProvider', '$logProvider', '$windowProvider', '$httpProvider', '$locationProvider', 'vAppConfigVPlusProvider', 'localStorageServiceProvider'];

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _common = require('./common/common');

var _common2 = _interopRequireDefault(_common);

var _components = require('./components/components');

var _components2 = _interopRequireDefault(_components);

var _app = require('./app.config');

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc overview
 * @name app-v-vplus
 * @description
 * # Module
 */
var app = angular.module('app-v-vplus', ['ngAria', 'ngSanitize', 'pascalprecht.translate', 'LocalStorageModule', 'v-core.config', 'v-core.auth', 'ngDialog', _common2.default, _components2.default]).config(_app2.default).name;

// App
// Modules
exports.default = app;

},{"./app.config":1,"./common/common":4,"./components/components":11}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ngdoc service
 * @name VAppConfigProvider
 * @description
 * # Keep the active order informations
 */
var VAppConfigProvider = function () {
    function VAppConfigProvider(vAppConfigVPlusProvider) {
        _classCallCheck(this, VAppConfigProvider);

        this.key = 'angular-app-v-vplus';
        this.appConfig = vAppConfigVPlusProvider.$get();
        this.appConfig[this.key] = angular.merge({ i18n: {} }, this.appConfig[this.key]);
    }

    /**
     * @ngdoc method
     * @name $get
     * @description
     * #
     * @return {Object} appConfig for angular-app-v-vplus
     */


    _createClass(VAppConfigProvider, [{
        key: '$get',
        value: function $get() {
            return this.appConfig[this.key];
        }
    }]);

    return VAppConfigProvider;
}();

exports.default = VAppConfigProvider;

VAppConfigProvider.$inject = ['appConfigProvider'];

},{}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _appConfig = require('./appConfig.provider');

var _appConfig2 = _interopRequireDefault(_appConfig);

var _vConsent = require('./v-consent.service');

var _vConsent2 = _interopRequireDefault(_vConsent);

var _vRole = require('./v-role.service');

var _vRole2 = _interopRequireDefault(_vRole);

var _vAuth = require('./v-auth.service');

var _vAuth2 = _interopRequireDefault(_vAuth);

var _vGtm = require('./v-gtm.service');

var _vGtm2 = _interopRequireDefault(_vGtm);

var _platform = require('./platform.service');

var _platform2 = _interopRequireDefault(_platform);

var _vHelper = require('./v-helper.service');

var _vHelper2 = _interopRequireDefault(_vHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc overview
 * @name v-common-vplus
 * @description
 * # Module
 */
exports.default = angular.module('v-common-vplus', []).provider('vAppConfigVPlus', _appConfig2.default).service('vConsentService', _vConsent2.default).service('vRoleService', _vRole2.default).service('vAuthService', _vAuth2.default).service('vGtmService', _vGtm2.default).service('vPlatformService', _platform2.default).service('vHelperService', _vHelper2.default).constant('vConstants', {
    IDSPROFILE: {
        IDSPROFILE_SSO: 'IDSPROFILE-EspaceClient-SSO',
        IDSPROFILE_Residential: 'IDSPROFILE-EspaceClient-Residentiel',
        IDSPROFILE_Business: 'IDSPROFILE-EspaceClient-Affaires'
    },
    ACCOUNT_TYPE: {
        RESIDENTIAL: 'RESIDENTIAL',
        BUSINESS: 'BUSINESS',
        HELIX: 'HELIX'
    },
    ERROR_TYPE: {
        MODAL: 'MODAL',
        BANNER: 'BANNER'
    }
}).name;

},{"./appConfig.provider":3,"./platform.service":5,"./v-auth.service":6,"./v-consent.service":7,"./v-gtm.service":8,"./v-helper.service":9,"./v-role.service":10}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ngdoc service
 * @name platform.service:VPlatformService
 * @description
 * # Keep the config parameters
 */
var VPlatformService = function () {
    function VPlatformService($log, vAppConfigVPlus) {
        _classCallCheck(this, VPlatformService);

        this.$log = $log;
        this.appConfig = vAppConfigVPlus;

        this.setPlatform();
    }

    /**
     * @ngdoc method
     * @name setPlatform
     * @description
     * #
     */


    _createClass(VPlatformService, [{
        key: 'setPlatform',
        value: function setPlatform() {

            this.$log.debug('[DEBUG] VPlatformService::setPlatform');

            this.platform = this.appConfig.PLATFORM;
        }

        /**
         * @ngdoc method
         * @name isEcw
         * @description
         * #
         * @return {boolean} platform == 'ecw'
         */

    }, {
        key: 'isEcw',
        value: function isEcw() {

            this.$log.debug('[DEBUG] VPlatformService::isEcw - platform: ', this.platform);

            return this.platform == 'ecw';
        }

        /**
         * @ngdoc method
         * @name isPrintEnabled
         * @description
         * #
         * @return {boolean} platform === ecw
         */

    }, {
        key: 'isPrintEnabled',
        value: function isPrintEnabled() {

            this.$log.debug('[DEBUG] VPlatformService::isPrintEnabled');

            return this.platform === 'ecw';
        }
    }]);

    return VPlatformService;
}();

exports.default = VPlatformService;


VPlatformService.$inject = ['$log', 'vAppConfigVPlus'];

},{}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ngdoc service
 * @name v-consent-terms.service:VConsentTermsService
 * @description
 * # Keep the active consent terms informations
 */
var VAuthService = function () {
    function VAuthService($log, $http, $q, $translate, $httpParamSerializerJQLike, vAppConfigVPlus, vConstants, commonConfig, framePingService) {
        _classCallCheck(this, VAuthService);

        this.$log = $log;
        this.$http = $http;
        this.$q = $q;
        this.$translate = $translate;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;

        this.appConfig = vAppConfigVPlus;
        this.vConstants = vConstants;
        this.commonConfig = commonConfig;
        this.framePingService = framePingService;

        this.authUrl = this.appConfig.AUTH_URL;
        this.authSuccessUrl = this.appConfig.AUTH_SUCCESS_URL;
        this.authStatusUrl = this.appConfig.AUTH_SUCCESS_URL;
        this.authType = this.appConfig.AUTH_TYPE;

        this.lang = $translate.use();

        this.requestsSettings = {
            cache: false,
            withCredentials: true,
            responseType: 'json',
            timeout: 1200
        };

        this.account = {
            accountType: null,
            accountId: null
        };
    }

    /**
     * @ngdoc method
     * @name authenticateWithDcc
     * @description
     * # Calls the DCC to authenticate.
     * @return {Object} promise Angular object
     */


    _createClass(VAuthService, [{
        key: 'authenticateWithDcc',
        value: function authenticateWithDcc(data) {

            this.$log.debug('[DEBUG] VAuthService::authenticateWithDcc');

            var serializedData = this.$httpParamSerializerJQLike(data);

            var requestData = angular.extend({}, this.requestsSettings, {
                url: this.authUrl,
                method: 'POST',
                data: serializedData,
                headers: { 'Content-type': 'application/x-www-form-urlencoded' }
            });

            return this.$http(requestData);
        }

        /**
         * @ngdoc method
         * @name handleAuthenticationResponse
         * @description
         * # Handles the DCC authentication response. Dealing with error message,
         * success message and unknown error
         * @return {Object} promise Angular object
         */

    }, {
        key: 'handleAuthenticationResponse',
        value: function handleAuthenticationResponse(response) {

            this.$log.debug('[DEBUG] VAuthService::handleAuthenticationResponse');

            var deferred = this.$q.defer();

            if (!this.isContentTypeJson(response.headers())) {
                this.$log.debug('[DEBUG] VAuthService::handleAuthenticationResponse - error - Received an HTML login request: ', response);

                deferred.reject(this.getExceptionErrorMessage());

                return deferred.promise;
            }

            if (response.data && response.data.status === 'error') {

                this.$log.debug('[DEBUG] VAuthService::handleAuthenticationResponse - status error: ', response);

                var errorMessage = response.data.errorMsg[this.lang];
                var errorDetail = response.data.errorDtl ? response.data.errorDtl[this.lang] : '';

                deferred.reject({
                    message: errorMessage,
                    detail: errorDetail
                });
            } else if (response.data && response.data.status === 'success') {
                this.$log.debug('[DEBUG] VAuthService::handleAuthenticationResponse - success: ', response);
                deferred.resolve(response.data);
            } else {
                this.$log.debug('[DEBUG] VAuthService::handleAuthenticationResponse - Unknown error: ', response);

                deferred.reject(this.getExceptionErrorMessage());
            }

            return deferred.promise;
        }
    }, {
        key: 'pingApi',


        /**
         * @ngdoc method
         * @name pingApi
         * @param data
         * @description
         * # We need to make a call to an authenticated part of the REST API
         * because it is the one that creates the cookies
         * @return {Object} promise Angular object
         */
        value: function pingApi(data) {
            var _this = this;

            var requestData = angular.extend({}, this.requestsSettings, {
                url: this.commonConfig.SERVICE_API_URL + this.commonConfig.SERVICE_API_PING
            });

            return this.$http(requestData).then(function (response) {
                return data;
            }).catch(function (error) {
                if (error.status === -1) {
                    return _this.framePingService.ping({
                        url: _this.commonConfig.SERVICE_API_URL + _this.commonConfig.SERVICE_API_PING,
                        timeout: _this.commonConfig.PING_TIMEOUT
                    });
                }
                _this.$log.debug('Auth validation GET call failed', error);
            });
        }
    }, {
        key: 'isContentTypeJson',


        /**
         * @ngdoc method
         * @name isContentTypeJson
         * @param headers
         * @description
         * # Checks the headers to validate if content is supposed to be json
         * @return {Boolean}
         */
        value: function isContentTypeJson(headers) {
            this.$log.debug('[DEBUG] VAuthService::isContentTypeJson - headers: ', headers);

            var isJson = false;

            if (headers) {
                isJson = /application\/json/.test(headers['content-type']);
            }

            return isJson;
        }
    }, {
        key: 'getExceptionErrorMessage',
        value: function getExceptionErrorMessage() {
            var message = this.$translate.instant('auth.error.exception.message');
            var detail = this.$translate.instant('auth.error.exception.detail');

            return { message: message, detail: detail };
        }

        /**
         * @ngdoc method
         * @name login
         * @param username
         * @param password
         * @description
         * # Send username password to service API for authentication
         * @return {Object} promise Angular object
         */

    }, {
        key: 'login',
        value: function login(username, password) {
            var _this2 = this;

            this.$log.debug('[DEBUG] VAuthService::login');

            var data = {
                username: username,
                password: password,
                type: this.authType,
                successurl: this.authSuccessUrl
            };

            var deferred = this.$q.defer();

            return this.authenticateWithDcc(data).then(function (responseData) {
                return _this2.handleAuthenticationResponse(responseData);
            }).then(function (responseData) {
                return _this2.pingApi(responseData);
            }).then(deferred.resolve).catch(function (err) {

                _this2.$log.debug('[DEBUG] VAuthService::login - error: ', err);

                if (err.key) {
                    deferred.reject(err);
                } else if (!(err instanceof Error) && err.message) {
                    var errorObj = {
                        message: err.message,
                        detail: err.detail
                    };
                    deferred.reject(errorObj);
                } else {
                    deferred.reject(_this2.getExceptionErrorMessage());
                }

                return deferred.promise;
            });
        }

        /**
         * @ngdoc method
         * @name getAuthStatus
         * @description
         * #
         * @return
         */

    }, {
        key: 'getAuthStatus',
        value: function getAuthStatus() {
            var _this3 = this;

            this.$log.debug('[DEBUG] VAuthService::getAuthStatus');

            return this.$http.get(this.authStatusUrl, this.requestsSettings).then(function (res) {

                var data = res.data;

                //TODO KPR
                if (!data || (typeof data === 'undefined' ? 'undefined' : _typeof(data)) != "object" || data.userId === "") {
                    throw "";
                }

                _this3.account.accountId = data.userId;

                if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === "object" && data.status === "success" && data.userId === "Anonymous") {
                    return _this3.account;
                }

                if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === "object" && data.status === "success" && data.userId !== "Anonymous") {

                    switch (data.identityDomain) {

                        case _this3.vConstants.IDSPROFILE.IDSPROFILE_Business:
                            _this3.account.accountType = _this3.vConstants.ACCOUNT_TYPE.BUSINESS;
                            break;

                        case _this3.vConstants.IDSPROFILE.IDSPROFILE_Residential:
                            _this3.account.accountType = _this3.vConstants.ACCOUNT_TYPE.RESIDENTIAL;
                            break;

                        case _this3.vConstants.IDSPROFILE.IDSPROFILE_SSO:
                            if (data.hasOwnProperty('selectedUser') === false) {
                                _this3.account.accountType = _this3.vConstants.ACCOUNT_TYPE.HELIX;
                            } else if (data.selectedUser.indexOf(':affaires') !== -1) {
                                _this3.account.accountType = _this3.vConstants.ACCOUNT_TYPE.BUSINESS;
                            } else if (data.selectedUser.indexOf(':residentiel') >= 0) {
                                _this3.account.accountType = _this3.vConstants.ACCOUNT_TYPE.RESIDENTIAL;
                            }
                            break;
                    }
                }

                return _this3.account;
            }).catch(function (err) {
                _this3.$log.debug('[DEBUG] VAuthService::getAuthStatus - error ', err);
                return null;
            });
        }

        /**
         * @ngdoc method
         * @name isAuthenticated
         * @description
         * #
         * @return {boolean} accountType != null
         */

    }, {
        key: 'isAuthenticated',
        value: function isAuthenticated() {

            this.$log.debug('[DEBUG] VAuthService::isAuthenticated');

            return this.account.accountType != null;
        }

        /**
         * @ngdoc method
         * @name isResidentialAccount
         * @description
         * #
         * @return {boolean} accountType === RESIDENTIAL
         */

    }, {
        key: 'isResidentialAccount',
        value: function isResidentialAccount() {

            this.$log.debug('[DEBUG] VAuthService::isResidentialAccount');

            return this.account.accountType === this.vConstants.ACCOUNT_TYPE.RESIDENTIAL;
        }

        /**
         * @ngdoc method
         * @name isBusinessAccount
         * @description
         * #
         * @return {boolean} accountType === BUSINESS
         */

    }, {
        key: 'isBusinessAccount',
        value: function isBusinessAccount() {

            this.$log.debug('[DEBUG] VAuthService::isBusinessAccount');

            return this.account.accountType === this.vConstants.ACCOUNT_TYPE.BUSINESS;
        }

        /**
         * @ngdoc method
         * @name isHelixAccount
         * @description
         * #
         * @return {boolean} accountType === HELIX
         */

    }, {
        key: 'isHelixAccount',
        value: function isHelixAccount() {

            this.$log.debug('[DEBUG] VAuthService::isHelixAccount');

            return this.account.accountType === this.vConstants.ACCOUNT_TYPE.HELIX;
        }

        /**
         * @ngdoc method
         * @name getAccountType
         * @description
         * #
         * @return accountType
         */

    }, {
        key: 'getAccountType',
        value: function getAccountType() {

            this.$log.debug('[DEBUG] VAuthService::getAccountType');

            return this.account.accountType;
        }
    }]);

    return VAuthService;
}();

exports.default = VAuthService;


VAuthService.$inject = ['$log', '$http', '$q', '$translate', '$httpParamSerializerJQLike', 'vAppConfigVPlus', 'vConstants', 'commonConfig', 'framePingService'];

},{}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VConsentService = function () {
    function VConsentService($log, $http, commonConfig, vAppConfigVPlus) {
        _classCallCheck(this, VConsentService);

        this.$log = $log;
        this.$http = $http;

        this.baseUrl = commonConfig.SERVICE_API_URL;
        this.consentApiUrl = vAppConfigVPlus.CONSENT_URI;
        this.trialApiUrl = vAppConfigVPlus.TRIAL_URI;
        this.oc11BaseUrl = commonConfig.OC11_BASE_URL;
        this.agreementAccepted = null;

        this.requestsSettings = {
            cache: false,
            withCredentials: true,
            responseType: 'json',
            timeout: 1200
        };
    }

    /**
     * @ngdoc method
     * @name getConsent
     * @description
     * #
     */


    _createClass(VConsentService, [{
        key: 'getConsent',
        value: function getConsent() {
            var _this = this;

            this.$log.debug('[DEBUG] VConsentService::getConsent');

            return this.$http.get(this.baseUrl + this.consentApiUrl, this.requestsSettings).then(function (res) {
                _this.$log.debug('DEBUG - VConsentService - isConsented:', res.data.consented);
                _this.agreementAccepted = res.data.consented;
                return res.data;
            }).catch(function (err) {
                _this.$log.debug('DEBUG - VConsentService - getConsent - error: ', err);
                return null;
            });
        }

        /**
         * @ngdoc method
         * @name getHelixTrialAcceptanceState
         * @description
         * # get consent terms acceptance state
         */

    }, {
        key: 'getHelixTrialAcceptanceState',
        value: function getHelixTrialAcceptanceState() {
            var _this2 = this;

            this.$log.debug('[DEBUG] VConsentService::getHelixTrialAcceptanceState');

            return this.$http.get(this.baseUrl + this.trialApiUrl, this.requestsSettings).then(function (res) {
                return res.data;
            }).catch(function (err) {
                _this2.$log.debug('[DEBUG] VConsentService::getHelixTrialAcceptanceState - error: ', err);

                // TODO : just to trace the error if is 404
                if (err.status === 404) {
                    _this2.$log.debug('[DEBUG] VConsentService::getHelixTrialAcceptanceState - error 404: data not previously added to database: Will be treat as consented = false');
                }

                // TODO : no error can block the page yet. It will be treat in future deliveries. By now, we set the consent as false if was any error
                return {
                    status: err.status,
                    res: err,
                    consented: false
                };

                // // error 404 : data not added to database: will be treat as consented = false
                // if(err.status === 404) {
                //     this.$log.debug('DEBUG - v-consent-terms.service - getHelixTrialAcceptanceState - error 404: data not previously added to database: Will be treat as consented = false');
                //     return {
                //         status: err.status,
                //         res: err,
                //         consented: false
                //     };
                // }
                // return null;
            });
        }

        /**
         * @ngdoc method
         * @name setConsentTermsAcceptanceState
         * @description
         * # set consent terms acceptance state
         */

    }, {
        key: 'sendAgreement',
        value: function sendAgreement() {
            var _this3 = this;

            this.$log.debug('[DEBUG] VConsentService::sendAgreement');

            var options = { headers: { "Content-Type": "application/json" } };

            return this.$http.post(this.baseUrl + this.consentApiUrl + "?consented=" + !this.agreementAccepted, null, options).then(function (res) {
                return res.status;
            }).catch(function (err) {
                _this3.$log.debug('[DEBUG] VConsentService::sendAgreement post::error - err: ', err);
                return null;
            });
        }

        /**
         * @ngdoc method
         * @name setHelixTrialAcceptanceState
         * @description
         * # get consent terms acceptance state
         */

    }, {
        key: 'setHelixTrialAcceptanceState',
        value: function setHelixTrialAcceptanceState() {
            var _this4 = this;

            this.$log.debug('[DEBUG] VConsentService::setHelixTrialAcceptanceState. url: ', this.baseUrl + this.trialApiUrl + "?consented=true");

            var options = { headers: { "Content-Type": "application/json" } };

            return this.$http.post(this.baseUrl + this.trialApiUrl + "?consented=true", null, options).then(function (res) {
                return res.status;
            }).catch(function (err) {
                _this4.$log.debug('[DEBUG] VConsentService::setHelixTrialAcceptanceState::error - err: ', err);
                return null;
            });
        }

        /**
         * @ngdoc method
         * @name updateOc11Profile
         * @description
         * # ask Oc11 to update his consent status in his profile
         */

    }, {
        key: 'updateOc11Profile',
        value: function updateOc11Profile() {
            var _this5 = this;

            this.$log.debug('[DEBUG] VConsentService::updateOc11Profile. url: ', this.oc11BaseUrl + 'rest/model/atg/userprofiling/ProfileActor/resynchronizeProfileFromPiw');

            var options = { headers: { "Content-Type": "application/json" } };

            return this.$http.post(this.oc11BaseUrl + 'rest/model/atg/userprofiling/ProfileActor/resynchronizeProfileFromPiw', null, options).then(function (res) {
                return true;
            }).catch(function (err) {
                _this5.$log.debug('[DEBUG] VConsentService::updateOc11Profile::error - err: ', err);
                return null;
            });
        }
    }]);

    return VConsentService;
}();

exports.default = VConsentService;


VConsentService.$inject = ['$log', '$http', 'commonConfig', 'vAppConfigVPlus'];

},{}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VGtmService = function () {
    function VGtmService($log, $window, vPlatformService) {
        _classCallCheck(this, VGtmService);

        this.$log = $log;
        this.vPlatformService = vPlatformService;
        this.dataLayer = $window.dataLayer = $window.dataLayer || [];

        // GTM 1
        this.gtmDataOpenModal = {
            'event': 'privilege',
            'eventCategory': 'magasinage',
            'eventAction': 'interagir avec un privilège',
            'eventLabel': 'adhérer'
        };

        // GTM 2
        this.gtmDataOpenAuthentification = {
            'event': 'privilege',
            'eventCategory': 'magasinage',
            'eventAction': 'interagir avec un privilège',
            'eventLabel': 'afficher l\'authentification'
        };

        // GTM 3
        this.gtmDataSigIn = {
            'event': 'privilege',
            'eventCategory': 'magasinage',
            'eventAction': 'interagir avec un privilège',
            'eventLabel': 'se connecter'
        };

        // GTM 4
        this.gtmDataSigInResult = {
            'event': 'signInResult',
            'accountType': ''
        };

        // GTM 5
        this.gtmDataSigUp = {
            'event': 'privilege',
            'eventCategory': 'magasinage',
            'eventAction': 'interagir avec un privilège',
            'eventLabel': 'inscription'
        };

        // GTM 6
        this.gtmDataForgottenCredential = {
            'event': 'privilege',
            'eventCategory': 'magasinage',
            'eventAction': 'interagir avec un privilège',
            'eventLabel': 'récupérer son mot de passe oublié'
        };

        // TODO: to be integrated
        // GTM 7
        this.gtmDataLoginClose = {
            'event': 'consentement',
            'eventCategory': '[espace client / magasinage]',
            'eventAction': 'interagir avec un privilège',
            'eventLabel': 'cliquer sur le bouton cancel ou fermer l\'overlay'
        };

        // GTM 8 (//GTM 5.1)
        this.gtmDataShowConsentForm = {
            'eventCategory': '[espace client / magasinage]',
            'metaLevel2': 'consentement de l\'utilisateur',
            'isConsentPossible': null
        };

        // GTM 10 (//GTM 5.2.1 & 5.2.2)
        this.gtmDataSendAgreement = {
            'event': 'consentement',
            'eventCategory': '[espace client / magasinage]',
            'eventAction': '[agree : withdrawal]'
        };

        // GTM 11 Show details
        this.gtmDataSeeMore = {
            'event': 'consentement',
            'eventCategory': '[espace client / magasinage]',
            'eventAction': 'interagir avec un privilège',
            'eventLabel': 'cliquer sur voir plus dans l\'overlay'
        };
    }

    /**
     * @ngdoc method
     * @name sendGtmData
     * @param gtmData
     * @param eventCategory
     * @description
     * #
     */


    _createClass(VGtmService, [{
        key: 'sendGtmData',
        value: function sendGtmData(gtmData) {
            var eventCategory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


            this.$log.debug('[DEBUG] VGtmService::sendGtmData');

            if (eventCategory) {
                gtmData.eventCategory = this.vPlatformService.isEcw() ? 'espace client' : 'magasinage';
            }

            this.$log.debug('[DEBUG] VGtmService::sendGtmData: ', JSON.stringify(gtmData));

            if (this.dataLayer.length > 0) {
                this.dataLayer.push(gtmData);
            }
        }
    }]);

    return VGtmService;
}();

exports.default = VGtmService;


VGtmService.$inject = ['$log', '$window', 'vPlatformService'];

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VHelperService = function () {
    function VHelperService($log, $rootScope, $window, $location, $anchorScroll, $timeout, vAppConfigVPlus, commonConfig, vPlatformService) {
        _classCallCheck(this, VHelperService);

        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.$location = $location;
        this.$anchorScroll = $anchorScroll;
        this.$timeout = $timeout;

        this.appConfig = vAppConfigVPlus;
        this.commonConfig = commonConfig;
        this.vPlatformService = vPlatformService;

        this.protectedVcomUrl = null;
        this.fromVcomUrl = null;
        this.redirectionUrlEcw = this.appConfig.REDIRECTION_URL;
        this.seeMoreUrl = this.appConfig.SEE_MORE_URL;
        this.defaultProtectedPage = "https://dev2-vcom-cl-prd.ext.videotron.com/residentiel/b/plus/plus-produit/N-1p4ah5z?Ntl=fr";

        //TODO: move to constants
        this.PROTECTED_VCOM_URL_PARAM = "protectedVcomUrl";
        this.VCOM_LOGIN_URL_PARAM = "fromVcomUrl";
        this.PERSONAL_INFORMATIONS_COLLECTED_PARAM = "personalInformationsCollected";
        this.PERSONALINFORMATIONSPURPOSESPARAM = "personalInformationsPurposes";
        this.TRIGGER = '?triggerConsent=true';
    }

    _createClass(VHelperService, [{
        key: "setProtectedVcomUrl",
        value: function setProtectedVcomUrl(protectedVcomUrl) {

            this.$log.debug('DEBUG - VHelperService - setProtectedVcomUrl: ', protectedVcomUrl);

            this.protectedVcomUrl = decodeURIComponent(protectedVcomUrl);
        }

        /**
         * @ngdoc method
         * @name initSeeMoreFlow
         * initialise details flow by site
         */

    }, {
        key: "initSeeMoreFlow",
        value: function initSeeMoreFlow() {

            this.$log.debug('DEBUG - VHelperService - initSeeMoreFlow');

            if (this.vPlatformService.isEcw()) {

                if (this.vPlatformService.isEcw()) {

                    this.fromVcomUrl = this.getUrlParameter(this.VCOM_LOGIN_URL_PARAM);
                    if (this.fromVcomUrl) {
                        this.$log.debug('DEBUG - VHelperService - query param: ', this.fromVcomUrl);
                        this.fromVcomUrl = this.fromVcomUrl;
                        this.$location.search(this.VCOM_LOGIN_URL_PARAM, null);
                    }

                    var protectedVcomUrl = this.getUrlParameter(this.PROTECTED_VCOM_URL_PARAM) == "true";
                    if (protectedVcomUrl) {
                        this.$log.debug('DEBUG - VHelperService - query param: ', protectedVcomUrl);
                        this.protectedVcomUrl = protectedVcomUrl;
                        this.$location.search(this.PROTECTED_VCOM_URL_PARAM, null);
                    }

                    var personalInformationsCollected = this.getUrlParameter(this.PERSONAL_INFORMATIONS_COLLECTED_PARAM) == "true";
                    if (personalInformationsCollected) {
                        this.$log.debug('DEBUG - VHelperService - query param: ', personalInformationsCollected);
                        this.scrollToHash = this.PERSONAL_INFORMATIONS_COLLECTED_PARAM;
                        this.$location.search(this.PERSONAL_INFORMATIONS_COLLECTED_PARAM, null);
                    }

                    var personalInformationsPurposes = this.getUrlParameter(this.PERSONALINFORMATIONSPURPOSESPARAM) == "true";
                    if (personalInformationsPurposes) {
                        this.$log.debug('DEBUG - VHelperService - query param: ', personalInformationsPurposes);
                        this.scrollToHash = this.PERSONALINFORMATIONSPURPOSESPARAM;
                        this.$location.search(this.PERSONAL_INFORMATIONS_COLLECTED_PARAM, null);
                    }

                    if (this.fromVcomUrl || personalInformationsCollected || personalInformationsPurposes) {
                        this.openConditions();

                        if (this.scrollToHash && this.scrollToHash.length > 0) {
                            this.scrollToAnchor(this.scrollToHash);
                        }
                    }
                }
            } else {
                this.seeMoreUrl = this.appConfig.SEE_MORE_URL;
            }
        }

        /**
         * @ngdoc method
         * @name goToAnchor
         * @description
         * # goto to anchor ECW
         */

    }, {
        key: "goToAnchor",
        value: function goToAnchor(hash) {

            this.$log.debug('DEBUG - VHelperService - goToAnchor - hash:', hash);

            this.openConditions();

            if (this.vPlatformService.isEcw()) {
                this.scrollToAnchor(hash);
            } else {
                this.onBtnSeeMore(hash);
            }
        }

        /**
         * @ngdoc method
         * @name openConditions
         * @description
         * #
         */

    }, {
        key: "openConditions",
        value: function openConditions() {
            var _this = this;

            this.$log.debug('DEBUG - VHelperService - openConditions');

            this.$timeout(function () {
                _this.$rootScope.$emit('v-open-conditions');
            }, 100);
        }

        /**
         * @ngdoc method
         * @name scrollToAnchor
         * @description
         * # scroll to anchor
         */

    }, {
        key: "scrollToAnchor",
        value: function scrollToAnchor(hash) {
            var _this2 = this;

            this.$log.debug('DEBUG - VHelperService - scrollToAnchor - hash: ', hash);

            if (this.vPlatformService.isEcw()) {

                this.$timeout(function () {
                    _this2.$anchorScroll.yOffset = 60;
                    _this2.$location.hash(hash);
                    _this2.$anchorScroll();
                    _this2.$location.hash('');
                }, 100);
            } else {
                this.onBtnSeeMore(hash);
            }
        }

        /**
         * @ngdoc method
         * @name onBtnSeeMore
         * @description
         * # Redirection from VCOM to privilege page on ECW
         */

    }, {
        key: "onBtnSeeMore",
        value: function onBtnSeeMore(hash) {

            this.$log.debug('DEBUG - VHelperService - onBtnSeeMore', hash);
            this.$log.debug('DEBUG - VHelperService - onBtnSeeMore', this.seeMoreUrl);

            if (this.seeMoreUrl) {
                this.$log.debug('DEBUG - VHelperService - onBtnSeeMore');

                var url = this.seeMoreUrl + '?' + this.VCOM_LOGIN_URL_PARAM + "=" + encodeURIComponent(this.$window.location.href);
                url += "&protectedVcomUrl=" + encodeURIComponent(this.protectedVcomUrl);
                if (hash) {
                    url += "&" + hash + "=true";
                }
                this.$log.debug('DEBUG - VHelperService - onBtnSeeMore: ', url);
                this.$window.location.href = url;
            }
        }

        /**
         * @ngdoc method
         * @name redirectToEntryPoint
         * @description
         * # Redirection to url from config file or reload page as appropriate
         */

    }, {
        key: "redirectToEntryPoint",
        value: function redirectToEntryPoint() {

            this.$log.debug('DEBUG - VHelperService - redirectToEntryPoint');
            this.$log.debug('DEBUG - VHelperService - redirectToEntryPoint - protectedVcomUrl: ', this.protectedVcomUrl);

            if (this.fromVcomUrl) {
                if (this.protectedVcomUrl) {
                    this.redirectToVcomProtectedPage();
                } else {
                    this.backToEntryPoint();
                }
            } else {
                this.$window.location.href = this.redirectionUrlEcw;
            }
        }

        /**
         * @ngdoc method
         * @name redirectToVcomProtectedPage
         * @description
         * # Redirection to url protected page PLP or PDP
         */

    }, {
        key: "redirectToVcomProtectedPage",
        value: function redirectToVcomProtectedPage() {
            var addTrigger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;


            this.$log.debug('DEBUG - VHelperService - redirectToProtectedPage');

            if (addTrigger) {
                if (this.protectedVcomUrl.indexOf('?')) {
                    this.TRIGGER = this.TRIGGER.replace('?', '&');
                }
                this.$window.location.href = this.protectedVcomUrl + this.TRIGGER;
            } else {
                this.$window.location.href = this.protectedVcomUrl;
            }
        }

        /**
         * @ngdoc method
         * @name backToEntryPoint
         * @description
         * # Redirection to login page
         */

    }, {
        key: "backToEntryPoint",
        value: function backToEntryPoint() {

            this.$log.debug('DEBUG - VHelperService - backToEntryPoint');

            if (this.fromVcomUrl) {
                this.$window.location.href = this.fromVcomUrl;
            } else {
                this.$window.location.href = this.redirectionUrlEcw;
            }
        }

        /**
         * @ngdoc method
         * @name getUrlParameter
         * @param param
         * @description
         * # get URL parametes in mode html - html5Mode(false)
         */

    }, {
        key: "getUrlParameter",
        value: function getUrlParameter(param) {

            this.$log.debug('DEBUG - VHelperService - getUrlParameter - param: ', param);

            // eslint-disable-next-line no-useless-escape
            param = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + param + '=([^&#]*)');
            var results = regex.exec(location.search);

            return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
        }
    }]);

    return VHelperService;
}();

exports.default = VHelperService;


VHelperService.$inject = ['$log', '$rootScope', '$window', '$location', '$anchorScroll', '$timeout', 'vAppConfigVPlus', 'commonConfig', 'vPlatformService'];

},{}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VRoleService = function () {
    function VRoleService($log, $http, $window, commonConfig, vAppConfigVPlus) {
        _classCallCheck(this, VRoleService);

        this.$log = $log;
        this.$http = $http;

        this.baseUrl = commonConfig.SERVICE_API_URL;
        this.rolesApiUrl = vAppConfigVPlus.ROLES_URL;
    }

    /**
     * @ngdoc method
     * @name getRoles
     * @description
     * #
     */


    _createClass(VRoleService, [{
        key: 'getRoles',
        value: function getRoles() {
            var _this = this;

            this.$log.debug('DEBUG - VRoleService - getRoles');

            return this.$http.get(this.baseUrl + this.rolesApiUrl).then(function (res) {
                return res.data;
            }).catch(function (err) {
                _this.$log.debug('DEBUG - VRoleService - getRoles: ', err);
                return null;
            });
        }
    }]);

    return VRoleService;
}();

exports.default = VRoleService;


VRoleService.$inject = ['$log', '$http', '$window', 'commonConfig', 'vAppConfigVPlus'];

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vVplusCheckMember = require("./v-vplus-check-member/v-vplus-check-member");

var _vVplusCheckMember2 = _interopRequireDefault(_vVplusCheckMember);

var _vVplusModalBase = require("./v-vplus-modal-base/v-vplus-modal-base");

var _vVplusModalBase2 = _interopRequireDefault(_vVplusModalBase);

var _vVplusAuth = require("./v-vplus-auth/v-vplus-auth");

var _vVplusAuth2 = _interopRequireDefault(_vVplusAuth);

var _vVplusConsent = require("./v-vplus-consent/v-vplus-consent");

var _vVplusConsent2 = _interopRequireDefault(_vVplusConsent);

var _vVplusConsentConditions = require("./v-vplus-consent-conditions/v-vplus-consent-conditions");

var _vVplusConsentConditions2 = _interopRequireDefault(_vVplusConsentConditions);

var _vVplusConsentDesc = require("./v-vplus-consent-desc/v-vplus-consent-desc");

var _vVplusConsentDesc2 = _interopRequireDefault(_vVplusConsentDesc);

var _vVplusConsentActions = require("./v-vplus-consent-actions/v-vplus-consent-actions");

var _vVplusConsentActions2 = _interopRequireDefault(_vVplusConsentActions);

var _vVplusConsentImg = require("./v-vplus-consent-img/v-vplus-consent-img");

var _vVplusConsentImg2 = _interopRequireDefault(_vVplusConsentImg);

var _vErrorLightBox = require("./v-error-light-box/v-error-light-box");

var _vErrorLightBox2 = _interopRequireDefault(_vErrorLightBox);

var _vErrorBanner = require("./v-error-banner/v-error-banner");

var _vErrorBanner2 = _interopRequireDefault(_vErrorBanner);

var _vVplusSpinner = require("./v-vplus-spinner/v-vplus-spinner");

var _vVplusSpinner2 = _interopRequireDefault(_vVplusSpinner);

var _vVplusModal = require("./v-vplus-modal/v-vplus-modal");

var _vVplusModal2 = _interopRequireDefault(_vVplusModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc overview
 * @name v-components
 * @description
 * # Module
 */
exports.default = angular.module('v-vplus-components', [_vVplusCheckMember2.default, _vVplusModalBase2.default, _vVplusAuth2.default, _vVplusConsent2.default, _vVplusConsentConditions2.default, _vVplusConsentDesc2.default, _vVplusConsentActions2.default, _vVplusConsentImg2.default, _vErrorLightBox2.default, _vErrorBanner2.default, _vVplusSpinner2.default, _vVplusModal2.default]).name;

},{"./v-error-banner/v-error-banner":15,"./v-error-light-box/v-error-light-box":19,"./v-vplus-auth/v-vplus-auth":23,"./v-vplus-check-member/v-vplus-check-member":28,"./v-vplus-consent-actions/v-vplus-consent-actions":32,"./v-vplus-consent-conditions/v-vplus-consent-conditions":36,"./v-vplus-consent-desc/v-vplus-consent-desc":40,"./v-vplus-consent-img/v-vplus-consent-img":44,"./v-vplus-consent/v-vplus-consent":48,"./v-vplus-modal-base/v-vplus-modal-base":52,"./v-vplus-modal/v-vplus-modal":57,"./v-vplus-spinner/v-vplus-spinner":61}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vErrorBanner = require('./v-error-banner.html');

var _vErrorBanner2 = _interopRequireDefault(_vErrorBanner);

var _vErrorBanner3 = require('./v-error-banner.controller');

var _vErrorBanner4 = _interopRequireDefault(_vErrorBanner3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc directive
 * @name v-error-banner: Component
 * @scope
 */
var vErrorBannerComponent = {
    bindings: {
        alertExtraClasses: '<',
        alertIsDismissible: '<',
        title: '<',
        message: '<',
        onClose: '&',
        isEcwPlateform: '<'
    },
    /* TODO : old version : check need of isEcwPlateform */
    template: _vErrorBanner2.default,
    controller: _vErrorBanner4.default
};

exports.default = vErrorBannerComponent;

},{"./v-error-banner.controller":13,"./v-error-banner.html":14}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ngdoc controller
 * @name v-error-banner:VErrorBannerController
 * @description
 * # Controller
 */
var VErrorBannerController = function () {
    function VErrorBannerController($translate, $log, $rootScope, vPlatformService) {
        _classCallCheck(this, VErrorBannerController);

        this.$log = $log;
        this.$rootScope = $rootScope;
        this.vPlatformService = vPlatformService;
    }

    _createClass(VErrorBannerController, [{
        key: 'onBtnClose',
        value: function onBtnClose() {
            this.$log.debug('[DEBUG] VErrorBannerController::onBtnClose ');

            this.onClose();

            // TODO: old version : check why was used
            // if (!this.vPlatformService.isEcw()) {
            //     this.$rootScope.$emit('v-close-modal-click');
            // }
        }
    }]);

    return VErrorBannerController;
}();

exports.default = VErrorBannerController;


VErrorBannerController.$inject = ['$translate', '$log', '$rootScope', 'vPlatformService'];

},{}],14:[function(require,module,exports){
module.exports = "<div class=\"alert fade show\" ng-class=\"[$ctrl.alertExtraClasses, {'alert--dismissible': $ctrl.alertIsDismissible}]\" role=alert title=\"\"><span class=alert__title ng-bind-html=$ctrl.title title=\"\"></span> <span class=alert__body title=\"\"><span class=alert__text ng-bind-html=$ctrl.message></span> </span><button type=button class=close data-dismiss=alert aria-label=Close ng-click=$ctrl.onBtnClose() ng-if=$ctrl.alertIsDismissible title=&times;><span aria-hidden=true>&times;</span></button></div>";

},{}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vErrorBanner = require('./v-error-banner.component');

var _vErrorBanner2 = _interopRequireDefault(_vErrorBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc overview
 * @name v-error-banner
 * @description
 * # Module
 */
exports.default = angular.module('v-error-banner', []).component('vErrorBanner', _vErrorBanner2.default).name;

},{"./v-error-banner.component":12}],16:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vErrorLightBox = require('./v-error-light-box.html');

var _vErrorLightBox2 = _interopRequireDefault(_vErrorLightBox);

var _vErrorLightBox3 = require('./v-error-light-box.controller');

var _vErrorLightBox4 = _interopRequireDefault(_vErrorLightBox3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc directive
 * @name v-error-light-box: Component
 * @scope
 */
var vErrorLightBoxComponent = {
    bindings: {
        message: '<',
        title: '<',
        caption: '<',
        onClose: '&',
        isEcwPlateform: '<'
    },
    template: _vErrorLightBox2.default,
    controller: _vErrorLightBox4.default
};

exports.default = vErrorLightBoxComponent;

},{"./v-error-light-box.controller":17,"./v-error-light-box.html":18}],17:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ngdoc controller
 * @name v-error-light-box:VErrorLightBoxController
 * @description
 * # Controller
 */
var VErrorLightBoxController = function () {
    function VErrorLightBoxController($translate, $log, $rootScope, vPlatformService) {
        _classCallCheck(this, VErrorLightBoxController);

        this.$log = $log;
        this.$rootScope = $rootScope;
        this.vPlatformService = vPlatformService;
    }

    /**
     * @ngdoc method
     * @name onBtnClose
     * @description
     * # emit action on click close modal
     */


    _createClass(VErrorLightBoxController, [{
        key: 'onBtnClose',
        value: function onBtnClose() {
            this.$log.debug('[DEBUG] VErrorLightBoxController::onBtnClose ');

            if (!this.vPlatformService.isEcw()) {
                this.$rootScope.$emit('v-close-modal-click');
            }

            this.onClose();
        }
    }]);

    return VErrorLightBoxController;
}();

exports.default = VErrorLightBoxController;


VErrorLightBoxController.$inject = ['$translate', '$log', '$rootScope', 'vPlatformService'];

},{}],18:[function(require,module,exports){
module.exports = "<div class=v-error-light-box><div class=\"card card--lightbox\"><div class=card-header><span ng-if=!$ctrl.message.caption ng-bind-html=\"'privilege-error.alert.title.error' | translate\"></span> <span ng-if=$ctrl.message.caption ng-bind-html=\"$ctrl.message.caption | translate\"></span></div><div class=card-body><h4 class=card-title ng-if=$ctrl.message.title>{{ $ctrl.message.title | translate }}</h4><p class=card-text>{{ $ctrl.message.message | translate }}</p></div></div></div>";

},{}],19:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vErrorLightBox = require('./v-error-light-box.component');

var _vErrorLightBox2 = _interopRequireDefault(_vErrorLightBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc overview
 * @name v-error-light-box
 * @description
 * # Module
 */
exports.default = angular.module('v-error-light-box', []).component('vErrorLightBox', _vErrorLightBox2.default).name;

},{"./v-error-light-box.component":16}],20:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vVplusAuth = require('./v-vplus-auth.controller');

var _vVplusAuth2 = _interopRequireDefault(_vVplusAuth);

var _vVplusAuth3 = require('./v-vplus-auth.html');

var _vVplusAuth4 = _interopRequireDefault(_vVplusAuth3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc directive
 * @name v-vplus-auth: VVplusConsentAuthComponent
 * @restrict E
 * @scope
 */
var VVplusAuthComponent = {
    bindings: {
        onLoginBegin: '&',
        onLoginEnd: '&'
    },
    controller: _vVplusAuth2.default,
    template: _vVplusAuth4.default
};

exports.default = VVplusAuthComponent;

},{"./v-vplus-auth.controller":21,"./v-vplus-auth.html":22}],21:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ngdoc controller
 * @name v-vplus-auth: Controller
 * @description
 * # Controller
 */

var VVplusAuthController = function () {
    function VVplusAuthController($log, $rootScope, $translate, $window, vAppConfigVPlus, vAuthService, vGtmService) {
        _classCallCheck(this, VVplusAuthController);

        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.$window = $window;

        this.vAuthService = vAuthService;
        this.vGtmService = vGtmService;

        this.signupUrl = vAppConfigVPlus.SIGNUP_URL;
    }

    _createClass(VVplusAuthController, [{
        key: '$onInit',
        value: function $onInit() {
            this.$log.debug('[DEBUG] VVplusAuthController::$onInit ');

            // GTM 2
            this.vGtmService.sendGtmData(this.vGtmService.gtmDataOpenAuthentification);
        }

        /**
         * @ngdoc method
         * @name login
         * @description
         * # Give login information to service
         */

    }, {
        key: 'login',
        value: function login() {
            var _this = this;

            this.$log.debug('[DEBUG] VVplusAuthController::login ');

            this.onLoginBegin();

            // GTM 3
            this.vGtmService.sendGtmData(this.vGtmService.gtmDataSigIn);

            this.vAuthService.login(this.authenticationForm.username.$modelValue, this.authenticationForm.password.$modelValue).then(function () {
                _this.$log.debug('DEBUG - v-authentication - authenticationAction - success');
                _this.onLoginEnd({ result: { logged: true, error: null } });

                _this.clearError();
                _this.clearForm();
            }).catch(function (err) {
                _this.$log.debug('DEBUG - v-authentication - authenticationAction - error', err);
                _this.onLoginEnd({ result: { logged: false, error: err } });

                _this.clearForm();
            });
        }

        /**
         * @ngdoc method
         * @name gotoSignUpPage
         */

    }, {
        key: 'gotoSignUpPage',
        value: function gotoSignUpPage() {
            this.$log.debug('[DEBUG] VVplusAuthController::gotoSignUpPage ');

            // GTM 5
            this.vGtmService.sendGtmData(this.vGtmService.gtmDataSigUp);
            this.$window.open(this.signupUrl, '_blank');
        }

        /**
         * @ngdoc method
         * @name clearForm
         * clear input components
         */

    }, {
        key: 'clearForm',
        value: function clearForm() {
            this.$log.debug('[DEBUG] VVplusAuthController::clearForm ');

            this.username = null;
            this.password = null;
        }

        /**
         * @ngdoc method
         * @name clearError
         * hide error component and clear error message
         */

    }, {
        key: 'clearError',
        value: function clearError() {}
        // this.$log.debug('[DEBUG] VVplusAuthController::clearError ');

        // this.anErrorHasOccurred = false;
        // this.errorMessage = '';


        /**
         * @ngdoc method
         * @name closeModal
         * @description
         * # emit action on click close modal
         */

    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.$log.debug('[DEBUG] VVplusAuthController::closeModal - `v-close-modal-click` emitted');

            this.$rootScope.$emit('v-close-modal-click');
        }

        /**
         * @ngdoc method
         * @name showError
         * show error component with error service message
         * @param err
         */

    }, {
        key: 'showError',
        value: function showError(err) {}
        // this.$log.debug('[DEBUG] VVplusAuthController::showError ');

        // this.anErrorHasOccurred = true;
        // this.errorMessage = err;


        /**
         * @ngdoc method
         * @name goToForgottenCredential
         *
         */

    }, {
        key: 'goToForgottenCredential',
        value: function goToForgottenCredential() {
            this.$log.debug('[DEBUG] VVplusAuthController::goToForgottenCredential ');

            // GTM 6
            this.vGtmService.sendGtmData(this.vGtmService.gtmDataForgottenCredential);

            var forgottenCredentialUrl = "/client/user-management/residentiel/secur/credential.do?dispatch=forgottenCredential";

            this.$window.open(forgottenCredentialUrl, '_blank');
        }
    }]);

    return VVplusAuthController;
}();

exports.default = VVplusAuthController;


VVplusAuthController.$inject = ['$log', '$rootScope', '$translate', '$window', 'vAppConfigVPlus', 'vAuthService', 'vGtmService'];

},{}],22:[function(require,module,exports){
module.exports = "<div class=v-vplus-auth><div class=v-vplus-auth__headed-content><div class=title>{{ 'auth.title' | translate }}</div><div class=description>{{ 'auth.title-description' | translate }}</div></div><div class=v-vplus-auth__left-content><div class=v-vplus-auth__content><form name=$ctrl.authenticationForm class=\"fn-setup-form-validation form\" ng-submit=$ctrl.login() novalidate><label class=form__label for=form-username>{{ 'auth.username' | translate }}</label><input id=form-username type=text class=\"form__input form-control\" name=username ng-model=$ctrl.username data-validate=true autocomplete=username required ng-required=true><p ng-show=\"$ctrl.authenticationForm.username.$error.required && $ctrl.authenticationForm.username.$touched\" class=validate-label>{{ 'auth.validation.username.required' | translate }}</p><label class=form__label for=form-password>{{ 'auth.password' | translate }}</label><input id=form-password type=password class=\"form__input form-control\" name=password ng-model=$ctrl.password data-validate=true autocomplete=current-password required><p ng-show=\"$ctrl.authenticationForm.password.$error.required && $ctrl.authenticationForm.password.$touched\" class=validate-label>{{ 'auth.validation.password.required' | translate }}</p><div class=form-action-container><button id=btnSignIn type=submit class=\"btn btn-sign-in fn-submit btn-yellow\" ng-disabled=$ctrl.authenticationForm.$invalid>{{'auth.action.sign-in'| translate }}</button> <a id=btnForgottenCredential class=\"btn-forgotten-credential link\" href=# ng-click=$ctrl.goToForgottenCredential()>{{ 'auth.action.forgotten-credential' | translate }}</a></div></form></div></div><div class=v-vplus-auth__right-content><div class=title-sign-up>{{ 'auth.sign-up.title' | translate }}</div><div class=description-sign-up>{{ 'auth.sign-up.title-description' | translate }}</div><button id=btn-sign-up class=\"btn btn-sign-up fn-submit\" type=button ng-click=$ctrl.gotoSignUpPage()>{{ 'auth.sign-up.action.sign-up' | translate }}</button></div></div>";

},{}],23:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vVplusAuth = require('./v-vplus-auth.component');

var _vVplusAuth2 = _interopRequireDefault(_vVplusAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc overview
 * @name v-vplus-auth
 * @description
 * # Module
 */
exports.default = angular.module('v-vplus-auth', []).component('vVplusAuth', _vVplusAuth2.default).name;

},{"./v-vplus-auth.component":20}],24:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vVplusCheckMember = require('./v-vplus-check-member.controller');

var _vVplusCheckMember2 = _interopRequireDefault(_vVplusCheckMember);

var _vVplusCheckMember3 = require('./v-vplus-check-member.html');

var _vVplusCheckMember4 = _interopRequireDefault(_vVplusCheckMember3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc directive
 * @name v-vplus-check-member: Component
 * @restrict E
 * @scope
 */
var VVplusCheckMemberComponent = {
    bindings: {
        label: '@',
        protectedVcomUrl: '@',
        ctaType: '@'
    },
    controller: _vVplusCheckMember2.default,
    template: _vVplusCheckMember4.default
};

exports.default = VVplusCheckMemberComponent;

},{"./v-vplus-check-member.controller":25,"./v-vplus-check-member.html":27}],25:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _vVplusCheckMemberDialogTemplate = require('./v-vplus-check-member.dialog.template.html');

var _vVplusCheckMemberDialogTemplate2 = _interopRequireDefault(_vVplusCheckMemberDialogTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ngdoc controller
 * @name v-vplus-check-member: VVplusCheckMemberController
 * @description
 * # Controller
 */
var VVplusCheckMemberController = function () {
    function VVplusCheckMemberController($log, $rootScope, $translate, ngDialog, vAppConfigVPlus, vGtmService, vHelperService, vPlatformService) {
        _classCallCheck(this, VVplusCheckMemberController);

        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$translate = $translate;

        this.ngDialog = ngDialog;

        this.appConfig = vAppConfigVPlus;
        this.vGtmService = vGtmService;
        this.vHelperService = vHelperService;
        this.vPlatformService = vPlatformService;

        this.isResDomain = null;
    }

    _createClass(VVplusCheckMemberController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$log.debug('[DEBUG] VVplusCheckMemberController::$onInit ');

            this.setBtnLabel();
            this.vHelperService.initSeeMoreFlow();

            if (this.protectedVcomUrl) {
                this.vHelperService.setProtectedVcomUrl(this.protectedVcomUrl);
            } else {
                this.vHelperService.setProtectedVcomUrl(this.appConfig.REDIRECTION_URL);
            }

            this.$rootScope.$on('v-close-modal-click', function () {
                _this.$log.debug('DEBUG - app-v-privilege-consent-terms-modal - `v-close-modal-click` received');

                _this.closeModal();
            });
        }

        /**
         * @ngdoc method
         * @name closeModal
         * @description
         * # call close binded function
         */

    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.$log.debug('[DEBUG] VVplusCheckMemberController::closeModal ');

            if (this.preCloseModal()) {
                this.ngDialog.close();
            }
        }

        /**
         * @ngdoc method
         * @name preCloseModal
         * @description
         * # check if the dialog must be closed only OR if the page must be redirected
         */

    }, {
        key: 'preCloseModal',
        value: function preCloseModal() {
            this.$log.debug('[DEBUG] VVplusCheckMemberController::preCloseModal');

            var classToRedirectWhenClose = ['.v-error-light-box', '.v-vplus-consent'];
            var redirect = false;
            for (var i = 0; i < classToRedirectWhenClose.length; i++) {
                var size = angular.element(document.querySelector(classToRedirectWhenClose[i])).length;
                if (size > 0) {
                    redirect = true;
                    break;
                }
            }
            if (redirect) {
                this.$log.debug('[DEBUG] VVplusCheckMemberController::preCloseModal : redirecting');

                this.vHelperService.redirectToEntryPoint();
                return false;
            }
            return true;
        }
    }, {
        key: 'setBtnLabel',
        value: function setBtnLabel() {
            this.$log.debug('[DEBUG] VVplusCheckMemberController::setBtnLabel');

            if (this.label) {
                this.btnText = this.label;
            } else {
                this.btnText = this.$translate.instant('privilege-modal.boutton.label.get-privilege');
            }
        }
    }, {
        key: 'openModal',
        value: function openModal() {
            var _this2 = this;

            this.$log.debug('[DEBUG] VVplusCheckMemberController::openModal ');

            // GTM 1
            this.vGtmService.sendGtmData(this.vGtmService.gtmDataOpenModal);

            this.ngDialog.open({
                template: _vVplusCheckMemberDialogTemplate2.default,
                controllerAs: '$ctrl',
                bindToController: true,
                closeByEscape: true,
                closeByDocument: true,
                preCloseCallback: function preCloseCallback() {
                    _this2.preCloseModal();
                },
                disableAnimation: true,
                showClose: true,
                plain: true,
                className: 'ngdialog ngdialog-theme-default v-flat-theme v-ui-components ng-dialog-v-privilege',
                bodyClassName: 'ngdialog-open-flat',
                data: { "isResDomain": this.isResDomain }
            });
        }
    }]);

    return VVplusCheckMemberController;
}();

exports.default = VVplusCheckMemberController;


VVplusCheckMemberController.$inject = ['$log', '$rootScope', '$translate', 'ngDialog', 'vAppConfigVPlus', 'vGtmService', 'vHelperService', 'vPlatformService'];

},{"./v-vplus-check-member.dialog.template.html":26}],26:[function(require,module,exports){
module.exports = "<div class=v-spinner ng-if=$ctrl.loading><div class=v-spinner__container><div ng-class=\"{'loading-spinner':$ctrl.loading}\"></div></div></div><ng-container ng-if=!$ctrl.loadingError><v-vplus-modal-base on-close-modal=$ctrl.closeModal()></v-vplus-modal-base></ng-container>";

},{}],27:[function(require,module,exports){
module.exports = "<button id=btn-show-modal class=\"btn btn-black btn-black-color-white\" ng-click=$ctrl.openModal() ng-if=\"$ctrl.ctaType == 'button'\">{{ $ctrl.btnText }}</button><div class=ctas><a href=\"\" ng-click=$ctrl.openModal() ng-if=\"$ctrl.ctaType == 'text'\" class=cta-link>{{ $ctrl.btnText }}</a></div>";

},{}],28:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vVplusCheckMember = require('./v-vplus-check-member.component');

var _vVplusCheckMember2 = _interopRequireDefault(_vVplusCheckMember);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc overview
 * @name v-vplus-check-member
 * @description
 * # Module
 */
exports.default = angular.module('v-vplus-check-member', []).component('vVplusCheckMember', _vVplusCheckMember2.default).name;

},{"./v-vplus-check-member.component":24}],29:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vVplusConsentActions = require('./v-vplus-consent-actions.controller');

var _vVplusConsentActions2 = _interopRequireDefault(_vVplusConsentActions);

var _vVplusConsentActions3 = require('./v-vplus-consent-actions.html');

var _vVplusConsentActions4 = _interopRequireDefault(_vVplusConsentActions3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc directive
 * @name v-vplus-consent-actions: Component
 * @restrict E
 * @scope
 */
var VVplusConsentActionsComponent = {
    bindings: {
        isEcw: '<',
        consented: '<',
        onRequestBegin: '&',
        onError: '&'
    },
    controller: _vVplusConsentActions2.default,
    template: _vVplusConsentActions4.default
};

exports.default = VVplusConsentActionsComponent;

},{"./v-vplus-consent-actions.controller":30,"./v-vplus-consent-actions.html":31}],30:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ngdoc controller
 * @name v-vplus-consent: VVplusConsentConditionsController
 * @description
 * # Controller
 */
var VVplusConsentActionsController = function () {
    function VVplusConsentActionsController($log, $rootScope, $window, $location, $anchorScroll, $translate, $q, vAppConfigVPlus, vPlatformService, vConsentService, vGtmService, vHelperService) {
        _classCallCheck(this, VVplusConsentActionsController);

        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.$location = $location;
        this.$anchorScroll = $anchorScroll;
        this.$translate = $translate;
        this.$q = $q;

        this.appConfig = vAppConfigVPlus;
        this.vPlatformService = vPlatformService;
        this.vGtmService = vGtmService;
        this.vConsentService = vConsentService;
        this.vHelperService = vHelperService;

        this.showSeeMoreBtn = !this.vPlatformService.isEcw();
    }

    _createClass(VVplusConsentActionsController, [{
        key: '$onInit',
        value: function $onInit() {

            this.$log.debug('[DEBUG] VVplusConsentActionsController::$onInit');

            this.btnLabelSendAgreement = this.$translate.instant('privilege-consent-terms.consent-terms.submit-button.label.' + (this.consented ? 'remove-consent' : 'accept-consent'));
        }

        /**
         * @ngdoc method
         * @name sendAgreement
         * @description
         * # Verification form validity and set consent acceptance state
         */

    }, {
        key: 'sendAgreement',
        value: function sendAgreement() {
            var _this = this;

            this.$log.debug('[DEBUG] VVplusConsentActionsController::sendAgreement');

            this.onRequestBegin();

            //GTM 10
            this.vGtmService.gtmDataSendAgreement.eventAction = this.consented ? 'withdrawal' : 'agree';
            this.vGtmService.sendGtmData(this.vGtmService.gtmDataSendAgreement, true);

            this.vConsentService.sendAgreement().then(function (status) {
                if (status === 200 || status === 204) {
                    _this.$log.debug('[DEBUG] VVplusConsentActionsController::sendAgreement from vConsentService.sendAgreement::success - success saved: ', status);
                    _this.vConsentService.updateOc11Profile().then(function (data) {
                        if (data) {
                            _this.vHelperService.redirectToEntryPoint();
                        } else {
                            _this.$log.debug('[DEBUG] VVplusConsentActionsController::updateOc11Profile from vConsentService.sendAgreement::error - err: ');
                            _this.onError();
                        }
                    }).catch(function (err) {
                        _this.$log.debug('[DEBUG] VVplusConsentActionsController::sendAgreement from vConsentService.sendAgreement::error - err: ', err);
                        _this.onError();
                    });
                } else {
                    _this.$log.debug('[DEBUG] VVplusConsentActionsController::sendAgreement from vConsentService.sendAgreement::success - unknown success code - status : ', status);
                    _this.onError();
                }
            }).catch(function (err) {
                _this.$log.debug('[DEBUG] VVplusConsentActionsController::sendAgreement from vConsentService.sendAgreement::error - err: ', err);
                _this.onError();
            });
        }

        /**
         * @ngdoc method
         * @name onBtCancel
         * @param label
         * @description
         * # Redirection or close modal as appropriate
         */

    }, {
        key: 'onBtnCancel',
        value: function onBtnCancel(label) {

            this.$log.debug('[DEBUG] VVplusConsentActionsController::onBtnCancel - label: ', label);

            // TODO: check this gtm : gtmDataCancelConsent does not exist
            // this.vGtmService.sendGtmData(this.vGtmService.gtmDataCancelConsent, this.$translate.instant(label), null, true);

            if (this.vPlatformService.isEcw()) {
                this.$log.debug('[DEBUG] VVplusConsentActionsController::onBtnCancel - isEcw: backToEntryPoint() ');
                this.vHelperService.backToEntryPoint();
            } else {
                this.$log.debug('[DEBUG] VVplusConsentActionsController::onBtnCancel - !isEcw: close Modal() ');
                this.$rootScope.$emit('v-close-modal-click');
            }
        }

        /**
         * @ngdoc method
         * @name onBtnSeeMore
         * @param label
         * @description
         * #
         */

    }, {
        key: 'onBtnSeeMore',
        value: function onBtnSeeMore(label) {

            this.$log.debug('[DEBUG] VVplusConsentActionsController::onBtnSeeMore - label: ', label);

            this.vGtmService.sendGtmData(this.vGtmService.gtmDataSeeMore, true);

            this.vHelperService.onBtnSeeMore();
        }
    }]);

    return VVplusConsentActionsController;
}();

exports.default = VVplusConsentActionsController;


VVplusConsentActionsController.$inject = ['$log', '$rootScope', '$window', '$location', '$anchorScroll', '$translate', '$q', 'vAppConfigVPlus', 'vPlatformService', 'vConsentService', 'vGtmService', 'vHelperService'];

},{}],31:[function(require,module,exports){
module.exports = "<div class=v-vplus-consent-actions ng-class=\"{ 'is-ecw' : $ctrl.isEcw }\"><form name=$ctrl.consentTermsForm><div class=\"form-action-container v-vplus-consent-actions__buttons\"><button id=btnSubmit type=submit class=\"btn btn__submit btn-yellow fn-submit\" ng-class=\"{ 'btn--xlarge' : $ctrl.consented }\" ng-click=$ctrl.sendAgreement()>{{ $ctrl.btnLabelSendAgreement }}</button> <a href=# id=btnLinkSeeMore class=\"btn-learn-more link\" ng-class=\"{ 'is-ecw' : $ctrl.isEcw }\" ng-if=$ctrl.showSeeMoreBtn ng-click=\"$ctrl.onBtnSeeMore( 'privilege-consent-terms.consent-terms.detail-button-plus.label-link' )\">{{ 'privilege-consent-terms.consent-terms.detail-button-plus.label-link' | translate }}</a></div></form></div>";

},{}],32:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vVplusConsentActions = require('./v-vplus-consent-actions.component');

var _vVplusConsentActions2 = _interopRequireDefault(_vVplusConsentActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc overview
 * @name v-vplus-consent-actions
 * @description
 * # Module
 */
exports.default = angular.module('v-vplus-consent-actions', []).component('vVplusConsentActions', _vVplusConsentActions2.default).name;

},{"./v-vplus-consent-actions.component":29}],33:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vVplusConsentConditions = require('./v-vplus-consent-conditions.controller');

var _vVplusConsentConditions2 = _interopRequireDefault(_vVplusConsentConditions);

var _vVplusConsentConditions3 = require('./v-vplus-consent-conditions.html');

var _vVplusConsentConditions4 = _interopRequireDefault(_vVplusConsentConditions3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc directive
 * @name v-vplus-consent: Component
 * @restrict E
 * @scope
 */
var VVplusConsentConditionsComponent = {
  controller: _vVplusConsentConditions2.default,
  template: _vVplusConsentConditions4.default
};

exports.default = VVplusConsentConditionsComponent;

},{"./v-vplus-consent-conditions.controller":34,"./v-vplus-consent-conditions.html":35}],34:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ngdoc controller
 * @name v-vplus-consent: VVplusConsentConditionsController
 * @description
 * # Controller
 */
var VVplusConsentConditionsController = function () {
    function VVplusConsentConditionsController($log, $rootScope, $translate, $http, vHelperService, vGtmService, commonConfig) {
        _classCallCheck(this, VVplusConsentConditionsController);

        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.$http = $http;
        this.vHelperService = vHelperService;
        this.vGtmService = vGtmService;
        this.commonConfig = commonConfig;

        this.detailsCollapsed = true;
        this.conditionsHTML = null;
    }

    _createClass(VVplusConsentConditionsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$log.debug('DEBUG - VVplusConsentConditionsController - $onInit');

            this.$rootScope.$on('v-open-conditions', function () {
                _this.$log.debug('DEBUG - VVplusConsentConditionsController - `$onInit` fetchHTML');
                _this.detailsCollapsed = false;
            });

            this.fetchConditions();
        }
    }, {
        key: 'onBtnSeeMoreCollaps',
        value: function onBtnSeeMoreCollaps() {

            this.$log.debug('DEBUG - VVplusConsentConditionsController - onBtnSeeMoreCollaps');

            this.detailsCollapsed = !this.detailsCollapsed;

            // GTM 11
            this.vGtmService.sendGtmData(this.vGtmService.gtmDataSeeMore, true);
        }
    }, {
        key: 'fetchConditions',
        value: function fetchConditions() {
            var _this2 = this;

            this.$log.debug('DEBUG - VVplusConsentConditionsController - fetchConditions');

            // TODO: add version variable in vcom fragment config 
            var url = this.commonConfig.FEW_URL + '/a/few/frg/angular-app-v-vplus/1.0.0-SNAPSHOT/details-' + this.$translate.use() + '.html';

            this.$log.debug('DEBUG - VVplusConsentConditionsController - fetchConditions - url: ', url);

            this.$http.get(url).then(function (result) {
                _this2.conditionsHTML = result.data;
            }).catch(function (err) {
                _this2.$log.warn('DEBUG - VVplusConsentConditionsController - fetchConditions - error ', err);
            });
        }
    }]);

    return VVplusConsentConditionsController;
}();

exports.default = VVplusConsentConditionsController;


VVplusConsentConditionsController.$inject = ['$log', '$rootScope', '$translate', '$http', 'vHelperService', 'vGtmService', 'commonConfig'];

},{}],35:[function(require,module,exports){
module.exports = "<div class=v-vplus-consent-conditions><div class=v-vplus-consent-conditions__show-more-wrapper><button id=btn-expand-see-more ng-if=$ctrl.detailsCollapsed class=collapse__header ng-class=\"{collapsed: $ctrl.detailsCollapsed}\" ng-click=$ctrl.onBtnSeeMoreCollaps() type=button><span>{{ 'privilege-consent-terms.consent-terms.detail-button-plus.label' | translate }}</span> <span class=ecw-icon-collapse></span></button></div><div class=collapse__content id=consent-detail ng-class=\"{collapse: $ctrl.detailsCollapsed}\"><div ng-bind-html=$ctrl.conditionsHTML></div></div><div class=v-vplus-consent-conditions__show-more-wrapper><button id=btn-expand-see-less class=collapse__header ng-if=!$ctrl.detailsCollapsed ng-class=\"{collapsed: $ctrl.detailsCollapsed}\" ng-click=$ctrl.onBtnSeeMoreCollaps() type=button><span>{{ 'privilege-consent-terms.consent-terms.detail-button-minus.label' | translate }}</span> <span class=ecw-icon-collapse></span></button></div></div>";

},{}],36:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vVplusConsentConditions = require('./v-vplus-consent-conditions.component');

var _vVplusConsentConditions2 = _interopRequireDefault(_vVplusConsentConditions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc overview
 * @name v-vplus-consent-conditions
 * @description
 * # Module
 */
exports.default = angular.module('v-vplus-consent-conditions', []).component('vVplusConsentConditions', _vVplusConsentConditions2.default).name;

},{"./v-vplus-consent-conditions.component":33}],37:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vVplusConsentDesc = require('./v-vplus-consent-desc.controller');

var _vVplusConsentDesc2 = _interopRequireDefault(_vVplusConsentDesc);

var _vVplusConsentDesc3 = require('./v-vplus-consent-desc.html');

var _vVplusConsentDesc4 = _interopRequireDefault(_vVplusConsentDesc3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc directive
 * @name v-vplus-consent-desc: Component
 * @restrict E
 * @scope
 */
var VVplusConsentDescComponent = {
    bindings: {
        consented: '<'
    },
    controller: _vVplusConsentDesc2.default,
    template: _vVplusConsentDesc4.default
};

exports.default = VVplusConsentDescComponent;

},{"./v-vplus-consent-desc.controller":38,"./v-vplus-consent-desc.html":39}],38:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ngdoc controller
 * @name v-vplus-consent: VVplusConsentDescController
 * @description
 * # Controller
 */
var VVplusConsentDescController = function () {
    function VVplusConsentDescController($log, vHelperService) {
        _classCallCheck(this, VVplusConsentDescController);

        this.$log = $log;
        this.vHelperService = vHelperService;
    }

    _createClass(VVplusConsentDescController, [{
        key: 'goToAnchor',
        value: function goToAnchor(hash) {
            this.$log.debug('DEBUG - VVplusConsentDescController - goToAnchor - hash: ', hash);

            this.vHelperService.goToAnchor(hash);
        }
    }]);

    return VVplusConsentDescController;
}();

exports.default = VVplusConsentDescController;


VVplusConsentDescController.$inject = ['$log', 'vHelperService'];

},{}],39:[function(require,module,exports){
module.exports = "<div class=v-vplus-consent-desc><p><span ng-bind-html=\"'privilege-consent-terms.consent-terms.description1' | translate\"></span> <span class=links ng-click=\"$ctrl.goToAnchor('personalInformationsCollected')\" ng-bind-html=\"'privilege-consent-terms.consent-terms.description2' | translate\"></span></p><p><span ng-bind-html=\"'privilege-consent-terms.consent-terms.description3' | translate\"></span></p><p><span ng-bind-html=\"'privilege-consent-terms.consent-terms.description4' | translate\"></span> <span class=links ng-click=\"$ctrl.goToAnchor('personalInformationsPurposes')\" ng-bind-html=\"'privilege-consent-terms.consent-terms.description5' | translate\"></span></p><p>{{ 'privilege-consent-terms.consent-terms.checkbox.detail.' + ($ctrl.consented ? 'remove-consent' : 'accept-consent') | translate }} <span ng-bind-html=\"'privilege-consent-terms.consent-terms.checkbox.detail.privacy' | translate\"></span></p></div>";

},{}],40:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vVplusConsentDesc = require('./v-vplus-consent-desc.component');

var _vVplusConsentDesc2 = _interopRequireDefault(_vVplusConsentDesc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc overview
 * @name v-vplus-consent-desc
 * @description
 * # Module
 */
exports.default = angular.module('v-vplus-consent-desc', []).component('vVplusConsentDesc', _vVplusConsentDesc2.default).name;

},{"./v-vplus-consent-desc.component":37}],41:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vVplusConsentImg = require('./v-vplus-consent-img.controller');

var _vVplusConsentImg2 = _interopRequireDefault(_vVplusConsentImg);

var _vVplusConsentImg3 = require('./v-vplus-consent-img.html');

var _vVplusConsentImg4 = _interopRequireDefault(_vVplusConsentImg3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc directive
 * @name v-vplus-consent-img: Component
 * @restrict E
 * @scope
 */
var VVplusConsentImgComponent = {
    bindings: {
        detailsCollapsed: '@'
    },
    controller: _vVplusConsentImg2.default,
    template: _vVplusConsentImg4.default
};

exports.default = VVplusConsentImgComponent;

},{"./v-vplus-consent-img.controller":42,"./v-vplus-consent-img.html":43}],42:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ngdoc controller
 * @name v-vplus-consent: VVplusConsentImgController
 * @description
 * # Controller
 */
var VVplusConsentImgController = function () {
    function VVplusConsentImgController($log, vAppConfigVPlus) {
        _classCallCheck(this, VVplusConsentImgController);

        this.$log = $log;
        this.descImgUrl = vAppConfigVPlus.CONSENT_DESC_IMG_URL;
    }

    _createClass(VVplusConsentImgController, [{
        key: '$onInit',
        value: function $onInit() {}
    }]);

    return VVplusConsentImgController;
}();

exports.default = VVplusConsentImgController;


VVplusConsentImgController.$inject = ['$log', 'vAppConfigVPlus'];

},{}],43:[function(require,module,exports){
module.exports = "<div class=v-vplus-consent-img ng-style=\"{'background-image':'url({{$ctrl.descImgUrl}})'}\"><div class=gradient ng-class=\"$ctrl.detailsCollapsed ? 'gradient--black': 'gradient--white' \"></div></div>";

},{}],44:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vVplusConsentImg = require('./v-vplus-consent-img.component');

var _vVplusConsentImg2 = _interopRequireDefault(_vVplusConsentImg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc overview
 * @name v-vplus-consent-img
 * @description
 * # Module
 */
exports.default = angular.module('v-vplus-consent-img', []).component('vVplusConsentImg', _vVplusConsentImg2.default).name;

},{"./v-vplus-consent-img.component":41}],45:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vVplusConsent = require('./v-vplus-consent.controller');

var _vVplusConsent2 = _interopRequireDefault(_vVplusConsent);

var _vVplusConsent3 = require('./v-vplus-consent.html');

var _vVplusConsent4 = _interopRequireDefault(_vVplusConsent3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc directive
 * @name v-vplus-consent: VVplusConsentAuthComponent
 * @restrict E
 * @scope
 */
var VVplusConsentComponent = {
    bindings: {
        isEcw: '<',
        isHelix: '<',
        onBtnTrialContinue: '&',
        consented: '<',
        onRequestBegin: '&',
        detailsCollapsed: '@',
        onError: '&'
    },
    controller: _vVplusConsent2.default,
    template: _vVplusConsent4.default
};

exports.default = VVplusConsentComponent;

},{"./v-vplus-consent.controller":46,"./v-vplus-consent.html":47}],46:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ngdoc controller
 * @name v-vplus-consent: Controller
 * @description
 * # Controller
 */

var VVplusConsentController = function () {
    function VVplusConsentController($log, $rootScope, $translate, $window, vAppConfigVPlus, vAuthService, vGtmService) {
        _classCallCheck(this, VVplusConsentController);

        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.$window = $window;

        this.vAuthService = vAuthService;
        this.vGtmService = vGtmService;

        this.signupUrl = vAppConfigVPlus.SIGNUP_URL;
    }

    _createClass(VVplusConsentController, [{
        key: '$onInit',
        value: function $onInit() {

            this.$log.debug('[DEBUG] VVplusConsentController::$onInit ');

            // GTM 2
            this.vGtmService.sendGtmData(this.vGtmService.gtmDataOpenAuthentification);
        }

        /**
         * @ngdoc method
         * @name login
         * @description
         * # Give login information to service
         */

    }, {
        key: 'login',
        value: function login() {
            var _this = this;

            this.$log.debug('[DEBUG] VVplusConsentController::login ');

            this.onLoginBegin();

            // GTM 3
            this.vGtmService.sendGtmData(this.vGtmService.gtmDataSigIn);

            this.vAuthService.login(this.authenticationForm.username.$modelValue, this.authenticationForm.password.$modelValue).then(function () {
                _this.$log.debug('DEBUG - v-authentication - authenticationAction - success');
                _this.onLoginEnd({ result: { logged: true, error: null } });

                _this.clearError();
                _this.clearForm();
            }).catch(function (err) {
                _this.$log.debug('DEBUG - v-authentication - authenticationAction - error', err);
                _this.onLoginEnd({ result: { logged: false, error: err } });

                _this.clearForm();
            });
        }

        /**
         * @ngdoc method
         * @name gotoSignUpPage
         */

    }, {
        key: 'gotoSignUpPage',
        value: function gotoSignUpPage() {
            this.$log.debug('[DEBUG] VVplusConsentController::gotoSignUpPage ');

            // GTM 5
            this.vGtmService.sendGtmData(this.vGtmService.gtmDataSigUp);
            this.$window.open(this.signupUrl, '_blank');
        }

        /**
         * @ngdoc method
         * @name clearForm
         * clear input components
         */

    }, {
        key: 'clearForm',
        value: function clearForm() {
            this.$log.debug('[DEBUG] VVplusConsentController::clearForm ');

            this.username = null;
            this.password = null;
        }

        /**
         * @ngdoc method
         * @name clearError
         * hide error component and clear error message
         */

    }, {
        key: 'clearError',
        value: function clearError() {}

        // this.$log.debug('[DEBUG] VVplusConsentController::clearError ');

        // this.anErrorHasOccurred = false;
        // this.errorMessage = '';


        /**
         * @ngdoc method
         * @name closeModal
         * @description
         * # emit action on click close modal
         */

    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.$log.debug('[DEBUG] VVplusConsentController::closeModal - `v-close-modal-click` emitted');

            this.$rootScope.$emit('v-close-modal-click');
        }

        /**
         * @ngdoc method
         * @name showError
         * show error component with error service message
         * @param err
         */

    }, {
        key: 'showError',
        value: function showError(err) {}
        // this.$log.debug('[DEBUG] VVplusConsentController::showError ');

        // this.anErrorHasOccurred = true;
        // this.errorMessage = err;


        /**
         * @ngdoc method
         * @name goToForgottenCredential
         *
         */

    }, {
        key: 'goToForgottenCredential',
        value: function goToForgottenCredential() {
            this.$log.debug('[DEBUG] VVplusConsentController::goToForgottenCredential ');

            // GTM 6
            this.vGtmService.sendGtmData(this.vGtmService.gtmDataForgottenCredential);

            var forgottenCredentialUrl = "/client/user-management/residentiel/secur/credential.do?dispatch=forgottenCredential";

            this.$window.open(forgottenCredentialUrl, '_blank');
        }
    }]);

    return VVplusConsentController;
}();

exports.default = VVplusConsentController;


VVplusConsentController.$inject = ['$log', '$rootScope', '$translate', '$window', 'vAppConfigVPlus', 'vAuthService', 'vGtmService'];

},{}],47:[function(require,module,exports){
module.exports = "<div class=v-vplus-consent><div class=v-vplus-consent__headed-content><div class=title ng-if=$ctrl.isHelix>{{ 'consent.helix.title' | translate }}</div><div class=title ng-if=!$ctrl.isHelix>{{ 'consent.title' | translate }}</div></div><div class=v-vplus-consent__left-content><ng-container ng-if=$ctrl.isHelix><div class=description-helix><div class=description>{{ 'consent.helix.description1' | translate }}</div><div class=description>{{ 'consent.helix.description2' | translate }}</div></div><div class=action-container><button id=btn-accept-trial class=\"btn btn-yellow\" ng-click=$ctrl.onBtnTrialContinue() type=button>{{ 'consent.helix.action.consent' | translate }}</button></div></ng-container><ng-container ng-if=!$ctrl.isHelix><v-vplus-consent-desc consented=$ctrl.consented></v-vplus-consent-desc><v-vplus-consent-actions is-ecw=$ctrl.isEcw consented=$ctrl.consented on-request-begin=$ctrl.onRequestBegin() on-error=$ctrl.onError()></v-vplus-consent-actions></ng-container></div><div class=v-vplus-consent__right-content><v-vplus-consent-img class=v-vplus-consent-img details-collapsed=$ctrl.detailsCollapsed></v-vplus-consent-img></div></div>";

},{}],48:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vVplusConsent = require('./v-vplus-consent.component');

var _vVplusConsent2 = _interopRequireDefault(_vVplusConsent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc overview
 * @name v-vplus-consent
 * @description
 * # Module
 */
exports.default = angular.module('v-vplus-consent', []).component('vVplusConsent', _vVplusConsent2.default).name;

},{"./v-vplus-consent.component":45}],49:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vVplusModalBase = require('./v-vplus-modal-base.controller');

var _vVplusModalBase2 = _interopRequireDefault(_vVplusModalBase);

var _vVplusModalBase3 = require('./v-vplus-modal-base.html');

var _vVplusModalBase4 = _interopRequireDefault(_vVplusModalBase3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc directive
 * @name v-vplus-modal-base: VVplusModalBaseComponent
 * @restrict E
 * @scope
 */
var VVplusModalBaseComponent = {
    bindings: {
        onCloseModal: '&'
    },
    controller: _vVplusModalBase2.default,
    template: _vVplusModalBase4.default
};

exports.default = VVplusModalBaseComponent;

},{"./v-vplus-modal-base.controller":50,"./v-vplus-modal-base.html":51}],50:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ngdoc controller
 * @name v-vplus-modal-base: VVplusModalBaseController
 * @description
 * # Controller
 */

var VVplusModalBaseController = function () {
    function VVplusModalBaseController($log, $q, $translate, vAppConfigVPlus, vPlatformService, vConsentService, vRoleService, vAuthService, vGtmService, vHelperService, vConstants) {
        _classCallCheck(this, VVplusModalBaseController);

        this.$log = $log;
        this.$q = $q;
        this.$translate = $translate;

        this.appConfig = vAppConfigVPlus;
        this.vPlatformService = vPlatformService;
        this.vGtmService = vGtmService;
        this.vConsentService = vConsentService;
        this.vRoleService = vRoleService;
        this.vAuthService = vAuthService;
        this.vHelperService = vHelperService;
        this.vConstants = vConstants;

        this.loadingError = false;
        this.showSpinner = true;
        this.showHelixMessage = false;
        this.consented = null;
        this.showSeeMoreBtn = !this.vPlatformService.isEcw();
        this.detailsCollapsed = true;
        this.descImgUrl = this.appConfig.CONSENT_DESC_IMG_URL;
        this.isEcwPlateform = this.vPlatformService.isEcw();
        this.errorMessage = {
            type: null,
            alertExtraClasses: '',
            alertIsDismissible: false,
            title: null,
            caption: null,
            message: null
        };
        this.setShowAuthentification(false);
        this.account = {
            accountType: null,
            accountId: null
        };
    }

    _createClass(VVplusModalBaseController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$log.debug('[DEBUG] VVplusModalBaseController::$onInit ');

            this.showSpinner = true;

            this.fetchAuthStatusAsync().then(function () {
                if (_this.vAuthService.isAuthenticated()) {
                    _this.initAutheticated();
                } else {
                    if (!_this.vPlatformService.isEcw()) {
                        _this.$log.debug('[DEBUG] VVplusModalBaseController::$onInit - from getAuthStatus - not authentificated - isEcw');
                        _this.setShowAuthentification(true);
                        _this.showSpinner = false;
                    } else {
                        _this.$log.warn('[DEBUG] VVplusModalBaseController::fetchAuthStatusAsync - error : no residential account');
                        // open error MODAL (new modal)
                        _this.showError('privilege-error.alert.text.error.no-residential-account');
                    }
                }
            }).catch(function (err) {
                _this.$log.war('[DEBUG] VVplusModalBaseController::$onInit - from getAuthStatus::error - err: ', err);

                // open error MODAL (new modal)
                _this.showError('privilege-error.alert.text.error.no-residential-account');
            });
        }
    }, {
        key: 'setShowAuthentification',
        value: function setShowAuthentification(show) {
            this.$log.debug('[DEBUG] VVplusModalBaseController::setShowAuthentification - show : ', show);

            this.showAuthentification = show;
            if (!show) {
                this.resetBannerError();
            }
        }
    }, {
        key: 'initAutheticated',
        value: function initAutheticated() {
            var _this2 = this;

            this.$log.debug('[DEBUG] VVplusModalBaseController::initAutheticated ');

            this.setShowAuthentification(false);

            //  It's an account Helix
            if (this.vAuthService.isHelixAccount()) {
                this.$log.warn('[DEBUG] VVplusModalBaseController::checkEligibility - isHelixAccount');

                this.trialActivated = false;

                return this.validateTrial().then(function () {
                    _this2.$log.debug('[DEBUG] VVplusModalBaseController::checkEligibility - result from validateTrial(VCOM)::success - trialActivated: ', _this2.trialActivated);

                    if (_this2.trialActivated) {
                        _this2.$log.debug('[DEBUG] VVplusModalBaseController::checkEligibility - result from validateTrial(VCOM)::success - trialActivated is activated');
                        _this2.vHelperService.redirectToEntryPoint();
                    } else {
                        _this2.$log.debug('[DEBUG] VVplusModalBaseController::checkEligibility - result from validateTrial(VCOM)::success - trialActivated is NOT activated');
                        _this2.showHelixMessage = true;
                        _this2.showSpinner = false;
                    }
                }).catch(function (err) {
                    _this2.$log.debug('[DEBUG] VVplusModalBaseController::checkEligibility - result from validateTrial(VCOM)::error - error: ', err);

                    _this2.addModalWidth();
                }).finally(function () {
                    return false;
                });
            }

            // It's a business account
            this.$log.info('[DEBUG] VVplusModalBaseController::checkEligibility - check isBusinessAccount: ', this.vAuthService.isBusinessAccount());
            if (this.vAuthService.isBusinessAccount()) {
                this.$log.info('[DEBUG] VVplusModalBaseController::checkEligibility - result from isBusinessAccount');

                // open error MODAL (new modal)
                this.showError('privilege-error.alert.text.error.no-residential-account');
                return false;
            }

            this.$q.all([this.fetchAgreementAsync(), this.fetchRolesAsync()]).then(function () {
                _this2.$log.warn('[DEBUG] VVplusModalBaseController::fetchConsentAsync::success');
                if (_this2.checkEligibility()) {
                    _this2.vHelperService.initSeeMoreFlow();
                }

                // GTM 8
                _this2.vGtmService.gtmDataShowConsentForm.isConsentPossible = _this2.isAdmin;
                _this2.vGtmService.sendGtmData(_this2.vGtmService.gtmDataShowConsentForm, true);
            }).catch(function (err) {
                _this2.$log.warn('[DEBUG] VVplusModalBaseController::fetchConsentAsync::error - error ', err);
                _this2.$log.warn('[DEBUG] VVplusModalBaseController::initAutheticated::error - error: ', err);

                // open error MODAL (new modal)
                _this2.showError('privilege-error.alert.text.error.generic');
            });
        }
    }, {
        key: 'fetchAuthStatusAsync',
        value: function fetchAuthStatusAsync() {
            var _this3 = this;

            this.$log.debug('[DEBUG] VVplusModalBaseController::fetchAuthStatus ');

            return this.vAuthService.getAuthStatus().then(function (data) {
                _this3.$log.debug('[DEBUG] VVplusModalBaseController::fetchAuthStatus::success - data: ', data);
                _this3.account = data;
            }).catch(function (err) {
                _this3.$log.warn('[DEBUG] VVplusModalBaseController::fetchAuthStatusAsync::error - error: ', err);
                _this3.loadingError = true;
            });
        }
    }, {
        key: 'fetchRolesAsync',
        value: function fetchRolesAsync() {
            var _this4 = this;

            this.$log.debug('[DEBUG] VVplusModalBaseController::fetchRolesAsync ');

            return this.vRoleService.getRoles().then(function (data) {
                _this4.$log.warn('data: %o\ntypeof data === "object": %o\ntypeof data.admin !== \'undefined\': %o ', data, (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === "object", typeof data.admin !== 'undefined');
                if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === "object" && typeof data.admin !== 'undefined') {
                    _this4.isAdmin = data.admin;
                } else {
                    _this4.$log.warn('[DEBUG] VVplusModalBaseController::fetchRolesAsync - error', data);

                    _this4.loadingError = true;
                }
            }).catch(function (err) {
                _this4.$log.warn('[DEBUG] VVplusModalBaseController::fetchRolesAsync - error ', err);

                _this4.loadingError = true;
            });
        }
    }, {
        key: 'fetchAgreementAsync',
        value: function fetchAgreementAsync() {
            var _this5 = this;

            this.$log.debug('[DEBUG] VVplusModalBaseController::fetchAgreementAsync ');

            return this.vConsentService.getConsent().then(function (data) {
                if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === "object" && data.consented !== undefined) {
                    _this5.consented = data.consented;
                } else {
                    _this5.$log.warn('[DEBUG] VVplusModalBaseController::fetchAgreementAsync - error');

                    _this5.loadingError = true;
                }
            }).catch(function (err) {
                _this5.$log.warn('[DEBUG] VVplusModalBaseController::fetchAgreementAsync - error: ', err);

                _this5.loadingError = true;
            });
        }
    }, {
        key: 'checkEligibility',
        value: function checkEligibility() {
            this.$log.debug('[DEBUG] VVplusModalBaseController::checkEligibility');

            if (this.loadingError) {
                this.$log.debug('[DEBUG] VVplusModalBaseController::checkEligibility - loadingError');

                // open error MODAL (new modal)
                this.showError('privilege-error.alert.text.error.generic');
                return false;
            }

            // already Authenticated
            if (this.vAuthService.isAuthenticated()) {
                this.$log.debug('[DEBUG] VVplusModalBaseController::checkEligibility - isAuthenticated!');

                this.setShowAuthentification(false);

                // 1. It's a secondary account without consent
                if (this.isAdmin == false) {
                    // 1.a. From ECW
                    if (this.vPlatformService.isEcw()) {
                        this.$log.warn('[DEBUG] VVplusModalBaseController::checkEligibility - (1.1) NOT admin && isEcw : showNonAdminMessage modal error');

                        // open error MODAL (new modal)
                        this.showError('privilege-error.alert.text.error.admin-required');
                        return false;
                    }
                    // 1.b. NOT Consented
                    if (!this.consented) {
                        this.$log.warn('[DEBUG] VVplusModalBaseController::checkEligibility - (1.b) NOT admin && NOT connected : showNonAdminMessage modal error');

                        // open error MODAL (new modal)
                        this.showError('privilege-error.alert.text.error.admin-required', this.vConstants.ERROR_TYPE.MODAL, true, null);
                        return false;
                    }
                }

                // 2. It's already consented, just redirect to protected page (pdp/plp)
                if (!this.vPlatformService.isEcw() && this.consented) {
                    this.$log.warn('[DEBUG] VVplusModalBaseController::checkEligibility - (2) NOT isEcw && consented : redirectToEntryPoint(UrlRedirect)');

                    this.showSpinner = true;
                    this.vHelperService.redirectToVcomProtectedPage(false);
                } else {
                    this.showSpinner = false;
                }

                return true;
            }

            if (this.isEcwPlateform) {
                this.$log.warn('[DEBUG] VVplusModalBaseController::checkEligibility - no-residential-account');

                // open error MODAL (new modal)
                this.showError('privilege-error.alert.text.error.generic');
                this.addModalWidth();
                return false;
            }
            return true;
        }
    }, {
        key: 'showModalError',
        value: function showModalError() {
            this.$log.debug('[DEBUG] VVplusModalBaseController::showModalError');

            return this.errorMessage.type === this.vConstants.ERROR_TYPE.MODAL;
        }
    }, {
        key: 'showBannerError',
        value: function showBannerError() {
            this.$log.debug('[DEBUG] VVplusModalBaseController::showBannerError');

            return this.errorMessage.type === this.vConstants.ERROR_TYPE.BANNER;
        }
    }, {
        key: 'onCloseModalError',
        value: function onCloseModalError() {
            this.$log.debug('[DEBUG] VVplusModalBaseController::onCloseModalError');
        }
    }, {
        key: 'onCloseBannerError',
        value: function onCloseBannerError() {
            this.$log.debug('[DEBUG] VVplusModalBaseController::onCloseBannerError');

            this.resetBannerError();
        }
    }, {
        key: 'resetBannerError',
        value: function resetBannerError() {
            this.$log.debug('[DEBUG] VVplusModalBaseController::resetBannerError');

            if (this.errorMessage && this.errorMessage.type) {
                this.errorMessage.type = null;
            }
            // special feature to hide the main button ngClose, if alertIsDismissible = true
            if (this.errorMessage && this.errorMessage.alertIsDismissible) {
                var result = angular.element(document.getElementsByClassName("ngdialog-close"));
                result.removeClass('hide');
            }
        }
    }, {
        key: 'showError',
        value: function showError(errorMessage) {
            var errorType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.vConstants.ERROR_TYPE.MODAL;
            var needTranlation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            var errorTitle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.$translate.instant('privilege-error.alert.title.error');

            this.$log.debug('[DEBUG] VVplusModalBaseController::showError');

            this.errorMessage.type = errorType;
            if (needTranlation) {
                this.errorMessage.message = this.$translate.instant(errorMessage);
                this.errorMessage.title = this.$translate.instant(errorTitle);
            } else {
                this.errorMessage.message = errorMessage;
                this.errorMessage.title = errorTitle;
            }

            if (this.errorMessage.type === this.vConstants.ERROR_TYPE.MODAL) {
                this.errorMessage.alertExtraClasses = '';
                this.errorMessage.alertIsDismissible = false;
                this.addModalWidth();
            } else {
                // TODO : set that dynamic, if needed
                this.errorMessage.alertExtraClasses = 'alert--banner alert--warning';
                this.errorMessage.alertIsDismissible = true;
                // special feature to hide the main button ngClose, if alertIsDismissible = true
                if (this.errorMessage.alertIsDismissible) {
                    var result = angular.element(document.getElementsByClassName("ngdialog-close"));
                    result.addClass('hide');
                }
            }
            this.showSpinner = false;
        }

        /**
         * @ngdoc method
         * @name validateTrial
         * validate agreement status
         */

    }, {
        key: 'validateTrial',
        value: function validateTrial() {
            var _this6 = this;

            this.$log.debug('[DEBUG] VVplusModalBaseController::validateTrial');

            return this.vConsentService.getHelixTrialAcceptanceState().then(function (data) {
                _this6.$log.debug('[DEBUG] VVplusModalBaseController::validateTrial::success - data: ', data);

                if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === "object" && data.consented !== undefined) {
                    // error 404 : data not added to database: will be treat as consented = false
                    if (data.status === 404) {
                        _this6.$log.debug('[DEBUG] VVplusModalBaseController::validateTrial - treatment from error 404');
                    }
                    _this6.trialActivated = data.consented;
                } else {
                    _this6.$log.debug('[DEBUG] VVplusModalBaseController::validateTrial - success, but empty - error ', 'undefined data.consented');
                    // TODO : no error can block the page yet. It will be treat in future deliveries. By now, we set the consent as false if was any error
                    // this.loadingError = true;
                    _this6.$log.debug('[DEBUG] VVplusModalBaseController::validateTrial - success, but empty - cannot block the page: Will be treat as consented = false');
                    _this6.trialActivated = false;
                }
            }).catch(function (err) {
                _this6.$log.debug('[DEBUG] VVplusModalBaseController::validateTrial::error - error : ', err);
                // TODO : no error can block the page yet. It will be treat in future deliveries. By now, we set the consent as false if was any error
                // this.loadingError = true;
                // this.addModalWidth();
                _this6.$log.debug('[DEBUG] app-v-privilege-consent-terms - validateTrial - error - error cannot block the page: Will be treat as consented = false');
                _this6.trialActivated = false;
            }).finally(function () {
                _this6.$log.debug('[DEBUG] VVplusModalBaseController::validateTrial::finally');
            });
        }

        /**
         * @ngdoc method
         * @name addModalWidth
         * @description
         * # Add modal class that set small width to de modal
         */

    }, {
        key: 'addModalWidth',
        value: function addModalWidth() {
            try {
                var result = angular.element(document.getElementsByClassName("ngdialog"));
                result.addClass('ngdialog-content-custom');
            } catch (e) {
                this.$log.error('[DEBUG] VVplusModalBaseController::addModalWidth - error: ', e);
            }
        }
    }, {
        key: 'onLoginBegin',
        value: function onLoginBegin() {
            this.showSpinner = true;
        }
    }, {
        key: 'onLoginEnd',
        value: function onLoginEnd(result) {
            var _this7 = this;

            this.$log.debug('[DEBUG] VVplusModalBaseController::onLoginEnd - accountType: ', this.vAuthService.account.accountType);

            if (!result) {
                // open error BANNER (at this same modal, on top)
                this.showError('privilege-error.alert.text.error.generic', this.vConstants.ERROR_TYPE.BANNER);
                return false;
            }

            if (result.logged) {
                this.fetchAuthStatusAsync().then(function () {

                    if (_this7.vAuthService.isAuthenticated() || result.logged) {
                        _this7.setShowAuthentification(false);

                        // GTM 4
                        _this7.vGtmService.gtmDataSigInResult.accountType = _this7.vAuthService.getAccountType();
                        _this7.vGtmService.sendGtmData(_this7.vGtmService.gtmDataSigInResult);

                        _this7.initAutheticated();
                    } else {
                        // open error MODAL (new modal)
                        _this7.showError('privilege-error.alert.text.error.generic');
                    }
                }).catch(function (err) {
                    _this7.$log.warn('[DEBUG] VVplusModalBaseController::fetchAgreementAsync::error - err: ', err);

                    // open error MODAL (new modal)
                    _this7.showError('privilege-error.alert.text.error.generic');
                    _this7.loadingError = true;
                });
            } else {
                this.$log.debug('[DEBUG] VVplusModalBaseController::onLoginEnd - ', result);

                if (result.error.message && result.error.detail) {
                    this.$log.debug('[DEBUG] VVplusModalBaseController::onLoginEnd - ', result);

                    // open error BANNER (at this same modal, on top)
                    this.showError(result.error.message + '<br>' + result.error.detail, this.vConstants.ERROR_TYPE.BANNER, false);
                } else {
                    // open error BANNER (at this same modal, on top)
                    this.showError('privilege-error.alert.text.error.generic', this.vConstants.ERROR_TYPE.BANNER);
                    this.loadingError = true;
                }
            }
        }
    }, {
        key: 'onRequestBegin',
        value: function onRequestBegin() {
            this.$log.debug('[DEBUG] VVplusModalBaseController::onRequestBegin');

            this.showSpinner = true;
        }
    }, {
        key: 'onBtnTrialContinue',
        value: function onBtnTrialContinue() {
            var _this8 = this;

            this.$log.info('[DEBUG] VVplusModalBaseController::onBtnTrialContinue');

            this.vConsentService.setHelixTrialAcceptanceState().then(function (successReturn) {
                if (successReturn === 200 || successReturn === 204) {
                    _this8.$log.debug('[DEBUG] VVplusModalBaseController::onBtnTrialContinue from setHelixTrialAcceptanceState:success - successReturn: ', successReturn);
                } else {
                    _this8.$log.debug('[DEBUG] VVplusModalBaseController::onBtnTrialContinue from setHelixTrialAcceptanceState:success - unknown success code from vConsentTermsService - successReturn: ', successReturn);
                }
            }).catch(function (err) {
                _this8.$log.debug('[DEBUG] VVplusModalBaseController::onBtnTrialContinue from setHelixTrialAcceptanceState:error - err: ', err);
            });

            this.vHelperService.redirectToEntryPoint();
        }
    }, {
        key: 'onError',
        value: function onError() {
            this.$log.debug('[DEBUG] VVplusModalBaseController::onError');

            // retrieve error from backend
            // open error MODAL (new modal)
            this.showError('privilege-error.alert.text.error.generic');
        }
    }]);

    return VVplusModalBaseController;
}();

exports.default = VVplusModalBaseController;


VVplusModalBaseController.$inject = ['$log', '$q', '$translate', 'vAppConfigVPlus', 'vPlatformService', 'vConsentService', 'vRoleService', 'vAuthService', 'vGtmService', 'vHelperService', 'vConstants'];

},{}],51:[function(require,module,exports){
module.exports = "<div class=v-vplus-modal-base><v-vplus-spinner ng-if=$ctrl.showSpinner use-v-symbol=false></v-vplus-spinner><v-error-light-box ng-if=\"!$ctrl.isResDomain && $ctrl.showModalError()\" message=$ctrl.errorMessage is-ecw-plateform=$ctrl.isEcwPlateform on-close=$ctrl.onCloseModalError()></v-error-light-box><div ng-if=\"!$ctrl.showSpinner && !(!$ctrl.isResDomain && $ctrl.showModalError())\"><div><v-error-banner ng-if=$ctrl.showBannerError() alert-extra-classes=$ctrl.errorMessage.alertExtraClasses alert-is-dismissible=$ctrl.errorMessage.alertIsDismissible title=$ctrl.errorMessage.title message=$ctrl.errorMessage.message on-close=$ctrl.onCloseBannerError()></v-error-banner><div class=v-vplus-modal-base__main-content><v-vplus-auth ng-if=$ctrl.showAuthentification class=v-vplus-modal-base__fragment on-login-begin=$ctrl.onLoginBegin() on-login-end=$ctrl.onLoginEnd(result)></v-vplus-auth><v-vplus-consent ng-if=!$ctrl.showAuthentification class=v-vplus-modal-base__fragment is-ecw=$ctrl.isEcwPlateform is-helix=$ctrl.showHelixMessage on-btn-trial-continue=$ctrl.onBtnTrialContinue() consented=$ctrl.consented on-request-begin=$ctrl.onRequestBegin() details-collapsed=$ctrl.detailsCollapsed on-error=$ctrl.onError()></v-vplus-consent></div><div ng-if=!$ctrl.showSeeMoreBtn><v-vplus-consent-conditions></v-vplus-consent-conditions></div></div></div></div>";

},{}],52:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vVplusModalBase = require('./v-vplus-modal-base.component');

var _vVplusModalBase2 = _interopRequireDefault(_vVplusModalBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc overview
 * @name v-vplus-modal-base
 * @description
 * # Module
 */
exports.default = angular.module('v-vplus-modal-base', []).component('vVplusModalBase', _vVplusModalBase2.default).name;

},{"./v-vplus-modal-base.component":49}],53:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vVplusModal = require('./v-vplus-modal.controller');

var _vVplusModal2 = _interopRequireDefault(_vVplusModal);

var _vVplusModal3 = require('./v-vplus-modal.html');

var _vVplusModal4 = _interopRequireDefault(_vVplusModal3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc directive
 * @name v-vplus-consent-img: Component
 * @restrict E
 * @scope
 */
/* TODO: delete all v-vplus-modal : is been replaced by v-vplus-check-member */

var VVplusModalComponent = {
    bindings: {
        label: '@',
        protectedVcomUrl: '@'
    },
    controller: _vVplusModal2.default,
    template: _vVplusModal4.default
};

exports.default = VVplusModalComponent;

},{"./v-vplus-modal.controller":54,"./v-vplus-modal.html":56}],54:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* TODO: delete all v-vplus-modal : is been replaced by v-vplus-check-member */

// import dialogController from './v-vplus-modal.dialog.controller'


var _vVplusModalDialogTemplate = require('./v-vplus-modal.dialog.template.html');

var _vVplusModalDialogTemplate2 = _interopRequireDefault(_vVplusModalDialogTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ngdoc controller
 * @name v-vplus-modal: VVplusModalController
 * @description
 * # Controller
 */
var VVplusModalController = function () {
    function VVplusModalController($log, $rootScope, $translate, ngDialog, vAppConfigVPlus, vHelperService, vGtmService, vPlatformService) {
        _classCallCheck(this, VVplusModalController);

        this.$log = $log;
        this.ngDialog = ngDialog;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.isResDomain = null;

        this.vHelperService = vHelperService;
        this.vGtmService = vGtmService;
        this.vPlatformService = vPlatformService;
        this.appConfig = vAppConfigVPlus;
    }

    _createClass(VVplusModalController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$log.debug('DEBUG - VVplusModalController - $onInit ');

            this.setBtnLabel();
            this.vHelperService.initSeeMoreFlow();

            if (this.protectedVcomUrl) {
                this.vHelperService.setProtectedVcomUrl(this.protectedVcomUrl);
            } else {
                this.vHelperService.setProtectedVcomUrl(this.appConfig.REDIRECTION_URL);
            }

            this.$rootScope.$on('v-close-modal-click', function () {
                _this.$log.debug('DEBUG - app-v-privilege-consent-terms-modal - `v-close-modal-click` received');
                _this.closeModal();
            });
        }
    }, {
        key: 'setBtnLabel',
        value: function setBtnLabel() {
            this.$log.debug('DEBUG - VVplusModalController - setBtnLabel');

            if (this.label) {
                this.btnText = this.label;
            } else {
                this.btnText = this.$translate.instant('privilege-modal.boutton.label.get-privilege');
            }
        }
    }, {
        key: 'openModal',
        value: function openModal() {
            this.$log.debug('DEBUG - VVplusModalController - openModal ');

            // GTM 1
            this.vGtmService.sendGtmData(this.vGtmService.gtmDataOpenModal);

            this.ngDialog.open({
                template: _vVplusModalDialogTemplate2.default,
                controllerAs: '$ctrl',
                bindToController: true,
                closeByEscape: true,
                closeByDocument: true,
                disableAnimation: true,
                showClose: true,
                plain: true,
                className: 'ngdialog ngdialog-theme-default v-flat-theme v-ui-components ng-dialog-v-privilege',
                bodyClassName: 'ngdialog-open-flat',
                data: { "isResDomain": this.isResDomain }
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.$log.debug('DEBUG - VVplusModalController - closeModal ');
            this.ngDialog.close();
        }
    }]);

    return VVplusModalController;
}();

exports.default = VVplusModalController;


VVplusModalController.$inject = ['$log', '$rootScope', '$translate', 'ngDialog', 'vAppConfigVPlus', 'vHelperService', 'vGtmService', 'vPlatformService'];

},{"./v-vplus-modal.dialog.template.html":55}],55:[function(require,module,exports){
module.exports = "<div class=v-spinner ng-if=$ctrl.loading><div class=v-spinner__container><div ng-class=\"{'loading-spinner':$ctrl.loading}\"></div></div></div><ng-container ng-if=\"!$ctrl.isLoading && !$ctrl.loadingError\"><v-vplus-consent on-close-modal=$ctrl.closeModal()></v-vplus-consent></ng-container>";

},{}],56:[function(require,module,exports){
module.exports = "<button id=btn-show-modal class=\"btn btn-medium btn-yellow\" ng-click=$ctrl.openModal()>{{$ctrl.btnText}}</button>";

},{}],57:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vVplusModal = require('./v-vplus-modal.component');

var _vVplusModal2 = _interopRequireDefault(_vVplusModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc overview
 * @name v-vplus-consent-img
 * @description
 * # Module
 */
exports.default = angular.module('v-vplus-modal', []).component('vVplusModal', _vVplusModal2.default).name; /* TODO: delete all v-vplus-modal : is been replaced by v-vplus-check-member */

},{"./v-vplus-modal.component":53}],58:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vVplusSpinner = require('./v-vplus-spinner.controller');

var _vVplusSpinner2 = _interopRequireDefault(_vVplusSpinner);

var _vVplusSpinner3 = require('./v-vplus-spinner.html');

var _vVplusSpinner4 = _interopRequireDefault(_vVplusSpinner3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc directive
 * @name v-vplus-spinner: VVplusSpinnerComponent
 * @restrict E
 * @scope
 */
var VVplusSpinnerComponent = {
    bindings: {
        useVSymbol: '@'
    },
    controller: _vVplusSpinner2.default,
    template: _vVplusSpinner4.default
};

exports.default = VVplusSpinnerComponent;

},{"./v-vplus-spinner.controller":59,"./v-vplus-spinner.html":60}],59:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ngdoc controller
 * @name v-vplus-spinner: VVplusSpinnerController
 * @description
 * # Controller
 */

var VVplusSpinnerController = function () {
    function VVplusSpinnerController($log, $interval) {
        _classCallCheck(this, VVplusSpinnerController);

        this.$log = $log;
        this.$interval = $interval;

        this.timer = 120;
        this.loadingInterval = '';

        // symbols sizes
        this.vSymbol_fullSize = 80;
        this.vSymbol_thickness = 15;
        this.plusSymbol_sideSize = 25;
        this.plusSymbol_thickness = 10;
        var svg_maxSizeX = 0;
        var svg_maxSizeY = 0;

        if (this.useVSymbol == 'true') {
            this.plusSymbol_posBaseX = this.vSymbol_fullSize;
            this.plusSymbol_posBaseY = (this.vSymbol_fullSize - (this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize)) / 2;
            svg_maxSizeX = this.vSymbol_fullSize + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize;
            svg_maxSizeY = this.vSymbol_fullSize;
        } else {
            this.plusSymbol_posBaseX = 0;
            this.plusSymbol_posBaseY = 0;
            svg_maxSizeX = this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize;
            svg_maxSizeY = this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize;
        }

        // symbols configurations
        var plusSymbol_allConfigs = {
            fullPath: 'M' + this.plusSymbol_posBaseX + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize) + ' ' + this.plusSymbol_posBaseY + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' ' + this.plusSymbol_posBaseY + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' L' + this.plusSymbol_posBaseX + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' Z',
            hideTop: 'M' + this.plusSymbol_posBaseX + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' L' + this.plusSymbol_posBaseX + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' Z',
            hideRight: 'M' + this.plusSymbol_posBaseX + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize) + ' ' + this.plusSymbol_posBaseY + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' ' + this.plusSymbol_posBaseY + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' L' + this.plusSymbol_posBaseX + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' Z',
            hideBottom: 'M' + this.plusSymbol_posBaseX + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize) + ' ' + this.plusSymbol_posBaseY + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' ' + this.plusSymbol_posBaseY + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' L' + this.plusSymbol_posBaseX + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' Z',
            hideLeft: 'M' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize) + ' ' + this.plusSymbol_posBaseY + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' ' + this.plusSymbol_posBaseY + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness + this.plusSymbol_sideSize) + ' L' + (this.plusSymbol_posBaseX + this.plusSymbol_sideSize) + ' ' + (this.plusSymbol_posBaseY + this.plusSymbol_sideSize + this.plusSymbol_thickness) + ' Z'
        };
        this.plusSymbol_pathCycleSteps = [plusSymbol_allConfigs.hideTop, plusSymbol_allConfigs.hideTop, plusSymbol_allConfigs.fullPath, plusSymbol_allConfigs.hideRight, plusSymbol_allConfigs.hideRight, plusSymbol_allConfigs.fullPath, plusSymbol_allConfigs.hideBottom, plusSymbol_allConfigs.hideBottom, plusSymbol_allConfigs.fullPath, plusSymbol_allConfigs.hideLeft, plusSymbol_allConfigs.hideLeft, plusSymbol_allConfigs.fullPath];
        this.plusSymbol_currentStepPos = 0;
        this.plusSymbol_lengthSteps = this.plusSymbol_pathCycleSteps.length - 1;
        var vSymbol_allConfigs = {
            fullPath: '\n                M0 0 \n                L' + (this.vSymbol_fullSize / 2 - this.vSymbol_thickness / 2) + ' ' + this.vSymbol_fullSize + ' \n                L' + (this.vSymbol_fullSize / 2 + this.vSymbol_thickness / 2) + ' ' + this.vSymbol_fullSize + ' \n                L' + this.vSymbol_fullSize + ' 0 \n                L' + (this.vSymbol_fullSize - this.vSymbol_thickness) + ' 0 \n                L' + this.vSymbol_fullSize / 2 + ' ' + (this.vSymbol_fullSize - this.vSymbol_thickness) + '  \n                L' + this.vSymbol_thickness + ' 0 \n            Z'
        };

        this.svg_width = svg_maxSizeX;
        this.svg_height = svg_maxSizeY;
        this.plusSymbol_currentPath = plusSymbol_allConfigs.fullPath;
        this.plusSymbol_currentPath = plusSymbol_allConfigs.fullPath;
        this.vSymbol_currentPath = vSymbol_allConfigs.fullPath;
    }

    _createClass(VVplusSpinnerController, [{
        key: '$onInit',
        value: function $onInit() {
            this.$log.warn('\n\n\n[DEBUG] VVplusSpinnerController::$onInit');

            // start loading
            this.startIntervalCycles();

            // remove 'close button' from modal
            var modalCloseBtn = angular.element(document.getElementsByClassName("ngdialog-close"));
            modalCloseBtn.addClass('hide');
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.$log.warn('[DEBUG] VVplusSpinnerController::$onDestroy\n\n\n');

            // re-install 'close button' from modal
            var modalCloseBtn = angular.element(document.getElementsByClassName("ngdialog-close"));
            modalCloseBtn.removeClass('hide');

            // stop loading
            this.stopIntervalCycles();
        }
    }, {
        key: 'switchCycleStep',
        value: function switchCycleStep() {
            this.$log.debug('[DEBUG] VVplusSpinnerController::switchCycleStep');

            // set only current cycle
            this.setCurrentCycleStep();

            // set next cycle position
            if (this.plusSymbol_currentStepPos === this.plusSymbol_lengthSteps) {
                this.plusSymbol_currentStepPos = 0;
            } else {
                this.plusSymbol_currentStepPos++;
            }
        }
    }, {
        key: 'setCurrentCycleStep',
        value: function setCurrentCycleStep() {
            this.$log.debug('[DEBUG] VVplusSpinnerController::setCurrentCycleStep');

            // set path to the PLUS symbol
            this.plusSymbol_currentPath = this.plusSymbol_pathCycleSteps[this.plusSymbol_currentStepPos];
        }
    }, {
        key: 'startIntervalCycles',
        value: function startIntervalCycles() {
            var _this = this;

            this.$log.debug('[DEBUG] VVplusSpinnerController::intervalCycles');

            this.loadingInterval = this.$interval(function () {
                _this.switchCycleStep();
            }, this.timer);
        }
    }, {
        key: 'stopIntervalCycles',
        value: function stopIntervalCycles() {
            this.$log.debug('[DEBUG] VVplusSpinnerController::intervalCycles');

            this.$interval.cancel(this.loadingInterval);
        }
    }]);

    return VVplusSpinnerController;
}();

exports.default = VVplusSpinnerController;


VVplusSpinnerController.$inject = ['$log', '$interval'];

},{}],60:[function(require,module,exports){
module.exports = "<div class=v-spinner-plus__container><div class=v-spinner-plus__content><svg ng-attr-width=\"{{ $ctrl.svg_width }}\" ng-attr-height=\"{{ $ctrl.svg_height }}\"><path ng-if=\"$ctrl.useVSymbol == 'true'\" class=v-symbol_path-container ng-attr-d=\"{{ $ctrl.vSymbol_currentPath }}\" d=0></path><path class=plus-symbol_path-container ng-attr-d=\"{{ $ctrl.plusSymbol_currentPath }}\" d=0></path></svg></div></div>";

},{}],61:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vVplusSpinner = require('./v-vplus-spinner.component');

var _vVplusSpinner2 = _interopRequireDefault(_vVplusSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ngdoc overview
 * @name v-vplus-spinner
 * @description
 * # Module
 */
exports.default = angular.module('v-vplus-spinner', []).component('vVplusSpinner', _vVplusSpinner2.default).name;

},{"./v-vplus-spinner.component":58}]},{},[2]);
